<template>
<div>
<modal v-model="modal" dir="right" :modalClass="['fill', revision !== null ? 'right xl h100' : 'right md h100']" :title="`${mobile ? '' : 'Transacción '}#${transaction ? Util.Zeropad(transaction.id_ticket, 10) : ''}`" hideActions>

	<i v-if="canOptions && revision == null && (isAdmin || (Auth.restrictions && Auth.restrictions.can_reprint))" class="options icon-printing ml5" slot="options" @click="VoucherOptions(transaction)"></i>
	<i v-if="canOptions && revision == null" class="options icon-dots-vertical ml5" slot="options" @click="Options([
		{text: 'Eliminar Transacción', class: 'error-color', if: canDelete && (Auth.role !== 'local_admin' || (Auth.role == 'local_admin' && !!Auth.restrictions_admin.can_delete_transactions)), function: () => ClickDeleteTransaction(), icon: 'trash'},
		{text: 'Cancelar Transacción', class: 'error-color', if: canCancel, function: () => OpenCancel(transaction), icon: 'forbidden'},
		{text: 'Editar Transacción', class: 'error-color', function: () => {EditCompletedTransaction()}, if: Auth.role == 'local_admin' || (transaction.status == 'COMPLETED' && (isAdmin || (Auth.restrictions && Auth.restrictions.can_edit_completed_transactions == 'EDIT_TRANSACTION'))), icon: 'edit'},
		{text: 'Editar Medio de Pago', class: 'error-color', function: () => {OpenEditPayment(transaction)}, if: transaction.status == 'COMPLETED' && (isAdmin || (Auth.restrictions && (Auth.restrictions.can_edit_completed_transactions == 'EDIT_PAYMENTS' || Auth.restrictions.can_edit_completed_transactions == 'EDIT_TRANSACTION'))), icon: 'bill-edit'},
		{text: 'Rembolsar', class: 'error-color', if: canRefund, function: RefundTransaction, confirm: `Se generará un gasto por ${Util.Price(transaction.total_money)} ¿Rembolsar transacción?`, icon: 'bill-rollback'},
		{text: 'Cancelar Boleta Electrónica', class: 'error-color', confirm: `Se emitirá una nota de crédito, ¿Desea confirmar?`, function: () => {sendNotaCredito()}, if: !!Local.modules.module_sii_boleta && !!Local.modules.module_sii_factura && !!transaction.id_boleta && transaction.custom_data.boleta.status == 'OK' && !transaction.custom_data.nota_credito, icon: 'invoice-cancel'},
		{text: 'Liquidar Pago Pendiente', function: () => {OpenPayPending()}, if: !!transaction.pending_payment && Local.type == 'LOCAL', icon: 'hourglass-check'},
		{text: 'Generar Voucher Digital', function: () => {ViewDigitalVoucher()}, icon: 'webpage'},
		{text: 'Emitir Boleta Electrónica', function: () => {SendBoleta()}, if: !transaction.id_boleta && !transaction.id_factura && !!Local.modules.module_sii_boleta, icon: 'invoice'},
		{text: 'Enviar Boleta Electrónica', function: () => {OpenModalSendBoleta()}, if: !!Local.modules.module_sii_boleta && !!transaction.id_boleta, icon: 'invoice-send'},
		{text: 'Enviar Nota de Crédito Electrónica', function: () => {OpenmodalSendDte(61)}, if: !!Local.modules.module_sii_factura && !!transaction.id_nota_credito && !!transaction.id_boleta, icon: 'factura-send'},
		{text: 'Emitir Factura Electrónica', function: () => {SendFactura()}, if: !transaction.custom_data.factura && !!Local.modules.module_sii_factura && !transaction.id_boleta && (Auth.role.indexOf('admin') > -1 || !!Auth.restrictions.can_create_facturas), icon: 'factura'},
		{text: 'Enviar Factura Electrónica', function: () => {OpenmodalSendDte()}, if: !!Local.modules.module_sii_factura && !!transaction.id_factura && !transaction.id_boleta, icon: 'factura-send'},
	])"></i>


	<i v-if="revision !== null" v-show="revision > 0" @click="revision--" slot="options" class="options icon-arrow-left mr5"></i>
	<input-select v-if="modal && revision !== null && revisions.length > 1" slot="options" v-model="revision" :items="revisions" inputClass="secondary" :icon="mobile ? 'history' : ''"></input-select>
	<i v-if="revision !== null" v-show="revision < revisions.length-1" @click="revision++" slot="options" class="options icon-arrow-right ml5"></i>

	<div v-if="revision !== null" class="w100 flex column pa10 relative" style="background-color: var(--yellow); color: var(--black); line-height: 1.1;">
		<i @click="revisions=[];revision=null" class="options icon-cross absolute" style="right: 5px; top: 5px"></i>
		<div class="flex fill">
			<div class="flex-fill w50 ta-center bold" v-if="desktop">{{ `Versión ${revision+1}` }}{{ revision == 0 ? ' (Inicial)' : '' }}</div>
			<div class="flex-fill w50 ta-center bold" v-else>{{ revision == 0 ? 'Inial' : `v${revision+1}` }}</div>
			<div class="unshrink"><i class="icon icon-right-arrow mr5" style="opacity: 0.5"></i> {{Util.Date(revisions[revisions.length - revision - 1].data.edit_at, 'HH:mm DD/MM/YYYY')}} <i class="icon icon-right-arrow ml5" style="opacity: 0.5"></i></div>
			<div class="flex-fill w50 ta-center bold" v-if="desktop">{{ `Versión ${revision+2}` }}{{ revision + 1 == revisions.length ? ' (Final)' : '' }}</div>
			<div class="flex-fill w50 ta-center bold" v-else>{{ revision + 1 == revisions.length ? 'Final' : ('v'+(revision+2)) }}</div>
		</div>
		<div class="flex-fill ta-center" style="font-size: 12px;">{{revisions[revisions.length - revision - 1].data.edit_by}} • {{ Util.TransactionRevisionsEvents[revisions[revisions.length - revision - 1].data.event] ? Util.TransactionRevisionsEvents[revisions[revisions.length - revision - 1].data.event] : revisions[revisions.length - revision - 1].data.event }} <span v-if="revisions[revisions.length - revision - 1].data.comment">({{ revisions[revisions.length - revision - 1].data.comment }})</span></div>
	</div>

	<div class="hdvm ofy copyable">
		<div v-for="(t, index) in previews" :key="index" :ref="`revisions`" class="fill ofy pa20" :style="index == 0 && previews.length > 1 ? (mobile ? {'border-bottom': '2px solid var(--yellow)'} : {'border-right': '2px solid var(--yellow)'}) : {}">

			<div class="">
				<!-- Log -->
				<div v-if="index == 0 || true">

					<div class="flex mb20 align-center" v-tooltip="Auth.role == 'admin' ? `ID: ${t.id}` : ''">
						<div class="f18">Historial</div>
						<div class="flex-fill relative">
							<button class="secondary absolute" style="top: -20px; right: 0" @click="GetRevision(t)" v-show="hasRevisions && previews.length == 1">Ver Cambios ({{ hasRevisions }})</button>
						</div>
					</div>

					<div class="mb15 revision-info">
						<div class="bold">{{Util.Date(t.created_at, 'LLLL')}}</div>
						<div>Transacción ingresada por {{t.custom_data.created_by}} <span v-if="t.paid_at == t.created_at">(Pagada)</span></div>
						<div class="secondary-text" v-if="t.custom_data.real_creation_date">Transacción creada el {{Util.Date(t.custom_data.real_creation_date, 'LLLL')}} con fecha pasada</div>
					</div>

					<div class="mb15 revision-info" v-if="t.custom_data.preparation_at">
						<div class="bold">{{Util.Date(t.custom_data.preparation_at, 'LLLL')}}</div>
						<div>Pedido empezó a prepararse</div>
					</div>

					<div class="mb15 revision-info" v-if="t.custom_data.takeaway_ready && t.custom_data.takeaway_ready !== true">
						<div class="bold">{{Util.Date(t.custom_data.takeaway_ready, 'LLLL')}}</div>
						<div>Pedido listo para retirar</div>
					</div>
					
					<div class="mb15 revision-info" v-if="t.delivery_at">
						<div class="bold">{{Util.Date(t.delivery_at, 'LLLL')}}</div>
						<div>Transacción enviada por {{t.custom_data.delivery_by}}</div>
						<!--<div>Transacción enviada por {{ticket.delivery.account.name}}</div>-->
					</div>

					<div class="mb15 revision-info" v-if="t.custom_data.delivered_at">
						<div class="bold">{{Util.Date(t.custom_data.delivered_at, 'LLLL')}}</div>
						<div>Transacción marcada como entregada por {{t.custom_data.delivered_by}}</div>
					</div>
					
					<div class="mb15 cgreen revision-info" v-if="t.completed_at">
						<div class="bold">{{Util.Date(t.completed_at, 'LLLL')}}</div>
						<div>Transacción completada por {{t.custom_data.completed_by}} <span v-if="t.paid_at == t.completed_at">(Pagada)</span></div>
						<!--<div>Transacción completada por {{ticket.completed.account.name}}</div>-->
					</div>
					<div class="mb15 cred revision-info" v-if="t.cancelled_at">
						<div class="bold">{{Util.Date(t.cancelled_at, 'LLLL')}}</div>
						<div>Transacción cancelada por {{t.custom_data.cancelled_by}} <span class="secondary-text" v-if="t.custom_data.cancelled_reason"> ({{t.custom_data.cancelled_reason}})</span></div>
						<!-- <div>Transacción cancelada por {{transaction.ticket.cancelled.account.name}} ({{ticket.cancelled.reason}})</div> -->
					</div>

					<div v-if="t.edit_at && Auth.role.indexOf('admin') > -1" class="flex mb15 revision-info">
						<div class="flex-fill">
							<div class="bold">Última vez editada</div>
							<div>{{Util.Date(t.edit_at, 'LLLL')}}</div>
						</div>
					</div>

					<div class="flex-col align-center mb15" v-if="t.custom_data && t.custom_data.reprint_historial && t.custom_data.reprint_historial.length">
						<div class="bold">Reimpresiones</div>
						<div class="mt revision-info small" v-for="(reprint, index) in t.custom_data.reprint_historial" :key="index">
							<div>{{Util.Date(reprint.timestamp, 'HH:mm DD/MM/YYYY')}} - Impresión {{Util.REPRINT_TYPES[reprint.types]}} por {{reprint.reprint_by}}</div>
						</div>
					</div>

					<div :class="`${TransactionStatus(t).class} revision-info`">
						<div class="bold">Estado</div>
						<div>{{TransactionStatus(t).text}}</div>
					</div>

				</div>
				
				<div v-if="t.id_boleta">
					
					<div class="separator mb20 mt20"></div>

					<div class="revision-info">
						<div class="flex align-center mb20">
							<div class="f18 flex-fill">Boleta Electrónica No. {{Util.Number(t.custom_data.boleta.folio)}} </div>
							<i v-if="Auth.role.indexOf('admin') > -1" class="options icon-dots-vertical" @click="Options([
								{text: 'Ver Detalles de Envío', function: () => {ShowBoletaLog()}, icon: 'information'},
								{text: 'Reenviar Boleta', function: () => {ResendBoleta()}, if: t.custom_data.boleta.status == 'RECIEVED_ERROR' || t.custom_data.boleta.status == 'RETRY_FAILED', icon: 'invoice'}
							])"></i>
						</div>
						
						<div class="hs mb15">
							<div>
								<div class="bold">Fecha</div>
								<div>{{t.custom_data.boleta.fecha_corta}}</div>
							</div>
							<div :class="` ${t.custom_data.boleta.status == 'OK' ? '' : 'cyellow'}`">
								<div class="bold">Estado</div>
								<div>{{boletaStatus[t.custom_data.boleta.status]}}</div>
							</div>
						</div>
						
						<div class="hs">
							<div>
								<div class="bold">Neto</div>
								<div>${{t.custom_data.boleta.neto}}</div>
							</div>
							<div>
								<div class="bold">IVA</div>
								<div>${{t.custom_data.boleta.iva}}</div>
							</div>
							<div>
								<div class="bold">Total</div>
								<div>${{t.custom_data.boleta.total}}</div>
							</div>
						</div>
					</div>
					
				</div>

				<div v-if="t.id_factura">
					<div class="separator mb20 mt20"></div>

					<div class="revision-info">
						<div class="f18 mb20">Factura Electrónica No. {{Util.Number(t.custom_data.factura.folio)}}</div>
						
						<div class="hs mb15">
							<div>
								<div class="bold">Fecha</div>
								<div>{{t.custom_data.factura.fecha_corta}}</div>
							</div>
							<div :class="` ${t.custom_data.factura.status == 'OK' ? '' : 'cyellow'}`">
								<div class="bold">Estado</div>
								<div :class="Util.FacturaStatus[t.custom_data.factura.status].color">{{Util.FacturaStatus[t.custom_data.factura.status].label }}</div>
							</div>
						</div>

						<div class="hs">
							<div>
								<div class="bold">Neto</div>
								<div>${{t.custom_data.factura.neto}}</div>
								<div v-if="parseFloat(t.custom_data.factura.exento.replace(/\./g, ''))">
									<div class="bold">Exento</div>
									<div>{{Util.Price(parseFloat(t.custom_data.factura.exento.replace(/\./g, '')))}}</div>
								</div>
							</div>
							<div>
								<div class="bold">IVA</div>
								<div>${{t.custom_data.factura.iva}}</div>
							</div>
							<div>
								<div class="bold">Total</div>
								<div>${{t.custom_data.factura.total}}</div>
							</div>
						</div>
					</div>
				</div>

				<div v-if="t.id_nota_credito">
					<div class="separator mb20 mt20"></div>

					<div class="revision-info">
						<div class="f18 mb20">Nota de Crédito Electrónica No. {{Util.Number(t.custom_data.nota_credito.folio)}}</div>
						
						<div class="hs mb15">
							<div>
								<div class="bold">Fecha</div>
								<div>{{t.custom_data.nota_credito.fecha_corta}}</div>
							</div>
							<div :class="` ${t.custom_data.nota_credito.status == 'OK' ? '' : 'cyellow'}`">
								<div class="bold">Estado</div>
								<div :class="Util.FacturaStatus[t.custom_data.nota_credito.status].color">{{Util.FacturaStatus[t.custom_data.nota_credito.status].label }}</div>
							</div>
						</div>
					</div>
				</div>

				<div class="">

					<div class="separator mb20 mt20"></div>

					<div class="f18 mb20">Datos del Pedido</div>

					<div class="mb15 revision-info" v-if="t.custom_data && t.custom_data.brand">
						<div class="bold">Marca</div>
						<div>{{t.custom_data.brand.name}}</div>
					</div>

					<div class="mb15 revision-info">
						<div class="bold">Tipo Pedido</div>
						<div>{{Util.TransactionType(t)}}</div>
					</div>

					<div class="mb15 revision-info" v-if="(t.custom_data && t.custom_data.customers_number)">
						<div class="bold">N° Comensales</div>
						<div>{{t.custom_data.customers_number}} <span v-if="DinersNames(t.custom_data.diners_names)">({{ DinersNames(t.custom_data.diners_names) }})</span></div>
					</div>

					<div class="mb15 revision-info" v-if="t.type == 'SERVE' && t.table_name">
						<div class="bold">Mesero</div>
						<div>{{t.custom_data.waiter ? t.custom_data.waiter.name : t.custom_data.created_by}}</div>
					</div>

					<div class="mb15 revision-info" v-if="t.type == 'DELIVERY' && t.custom_data.delivery_by">
						<div class="bold">Repartidor</div>
						<div>{{t.custom_data.delivery_by}}</div>
					</div>

					<div class="mb15 revision-info" v-if="t.custom_data.delivery_time">
						<div class="bold">Hora Entrega</div>
						<div>{{t.custom_data.delivery_time}}</div>
					</div>

					<div class="mb15 revision-info" v-if="t.custom_data.activation_time && !t.custom_data.shipment">
						{{ `Hora ${t.type == 'SERVE' ? 'Servir' : 'Retiro'}` }}
						<div>{{t.custom_data.activation_time}}</div>
					</div>

					<div class="mb15 revision-info" v-if="t.custom_data.scheduled_at">
						<div class="bold">Fecha Programado</div>
						<div>{{Util.Date(t.custom_data.scheduled_at, 'DD/MM/YYYY HH:mm')}}</div>
					</div>

					<div class="mb15 revision-info" v-if="t.type != 'TAKEAWAY' && t.custom_data.shipment">
						<div class="bold">Envío</div>
						<div v-if="t.custom_data.shipment.shipment_end">entre el {{Util.Date(t.custom_data.shipment.shipment_start, 'D [de] MMMM')}} y el {{Util.Date(t.custom_data.shipment.shipment_end, 'D [de] MMMM')}}</div>
						<div v-else>el {{Util.Date(t.custom_data.shipment.shipment_start, 'D [de] MMMM')}} <span v-if="t.custom_data.shipment.time">{{t.custom_data.shipment.time}}</span></div>
					</div>

					<div class="mb15 revision-info" v-if="t.type == 'TAKEAWAY' && t.custom_data.shipment">
						<div class="bold">Retiro</div>
						<div v-if="t.custom_data.shipment.shipment_end_takeaway">entre el {{Util.Date(t.custom_data.shipment.shipment_start_takeaway, 'D [de] MMMM')}} y el {{Util.Date(t.custom_data.shipment.shipment_end_takeaway, 'D [de] MMMM')}}</div>
						<div v-else>el {{Util.Date(t.custom_data.shipment.shipment_start_takeaway, 'D [de] MMMM')}} <span v-if="t.custom_data.shipment.time">{{t.custom_data.shipment.time}}</span></div>
					</div>

					<div class="mb15 flex revision-info" v-if="t.customer.name">
						<div class="flex-fill">
							<div class="bold">Cliente</div>
							<div>{{t.customer.name}} <i class="icon icon-corbatin" v-if="t.id_user" style="color: rgb(0,151,255)"></i></div>
						</div>
						<i v-if="canBlockCustomers" class="options icon-dots-vertical" @click="Options([
							{text: 'Bloquear Cliente', class: 'error-color', function: () => {BlockCustomer(t)}, confirm: `¿Bloquear cliente con número ${t.customer.phone}?`, icon: 'block-user'},
						])"></i>
					</div>
					<div class="mb15 flex revision-info" v-if="t.customer.rut">
						<div class="flex-fill">
							<div class="bold">RUT</div>
							<div>{{Util.Rut(t.customer.rut)}}</div>
						</div>	
					</div>
					<div class="mb15 flex revision-info" v-if="t.customer.address">
						<div class="flex-fill">
							<div class="bold">Dirección</div>
							<div>{{t.customer.address}}</div>
							<div class="secondary-text" v-if="t.custom_data.maps_address">Dirección registrada en el mapa: {{t.custom_data.maps_address}}</div>
						</div>
						
						<i v-if="canOptions" class="options icon-dots-vertical" @click="CustomerOptions(t, 'ADDRESS')"></i>
						
					</div>



					<div class="mb15 flex revision-info" v-if="t.customer.phone">
						<div class="flex-fill">
							<div class="bold">Contacto </div>
							<div>{{t.customer.phone}}</div>
						</div>
						
						<i v-if="canOptions" class="options icon-dots-vertical" @click="CustomerOptions(t, 'PHONE')"></i>
						
					</div>

					<div class="mb15 revision-info" v-if="t.customer.email">
						<div class="bold">Email </div>
						<div>{{t.customer.email}}</div>
					</div>

					<!--
					<div class="input-style" v-if="t.custom_data.influye_code">
						<div class="input-label">Código Influye </div>
						<div>{{t.custom_data.influye_code}}</div>
					</div>
					-->
					
				</div>

				<div class="revision-info" v-if="t.custom_data.integration_pya">
					<div class="separator mb20 mt20"></div>

					<div class="flex mb20 align-center">

						<div class="f18 flex-fill">Datos de PedidosYa</div>

						<!-- <i v-if="canOptions && t.custom_data.integration_pya" class="options icon-dots-vertical" @click="Options([
							{text: 'Ver Detalles de Envío', function: () => {ShowPyaCourierLog()}, if: Auth.role.indexOf('admin') > -1},
							{text: 'Ver PIN', function: () => {ShowPyaCourierPIN()}},
							{text: 'Soporte', function: () => { Util.Open(t.custom_data.integration_pya.onlineSupportUrl) } },
							{text: 'Seguir Envío', function: () => { Util.Open(t.custom_data.integration_pya.shareLocationUrl) }, if: t.custom_data.integration_pya.shareLocationUrl },
						])"></i> -->
					</div>

					<div v-if="t.custom_data.integration_pya">
						<div class="hdvm mb15">
							<div>
								<div class="bold">Código de confirmación </div>
								<div>{{t.custom_data.integration_pya.code}}</div>
							</div>
						</div>
						
						<!-- <div class="hdvm mb15">
							<div>
								<div class="bold">Recolección</div>
								<div>{{Util.Date(t.custom_data.integration_pya.pickupTime, 'HH:mm DD/MM/YYYY')}}</div>
							</div>

							<div>
								<div class="bold">Entrega</div>
								<div>{{Util.Date(t.custom_data.integration_pya.deliveryTime, 'HH:mm DD/MM/YYYY')}}</div>
							</div>
						</div> -->

						<div class="" v-if="Util.StatusOrderPya[t.custom_data.integration_pya.status]">
							<div class="bold">Estado </div>
							<div>{{Util.StatusOrderPya[t.custom_data.integration_pya.status]}}</div>
							<div class="secondary-text" v-if="t.custom_data.integration_pya.cancelReason">{{ t.custom_data.integration_pya.cancelReason }}</div>
						</div>
					</div>
				</div>

				<div class="revision-info" v-if="t.custom_data.integration_uber_eats">
					<div class="separator mb20 mt20"></div>

					<div class="flex mb20 align-center">
						<div class="f18 flex-fill">Datos de Uber Eats</div>
					</div>

					<div v-if="t.custom_data.integration_uber_eats">
						<div class="hdvm mb15" v-if="t.custom_data.integration_uber_eats.display_id">
							<div>
								<div class="bold">ID</div>
								<div>{{t.custom_data.integration_uber_eats.display_id}}</div>
							</div>
						</div>

						<div class="" v-if="Util.StatusOrderIntegrationUE[t.custom_data.integration_uber_eats.status]">
							<div class="bold">Estado </div>
							<div>{{Util.StatusOrderIntegrationUE[t.custom_data.integration_uber_eats.status]}}</div>
						</div>
					</div>
				</div>

				<div class="revision-info" v-if="t.custom_data.pedidosya_courier || t.custom_data.pedidosya_status">
					<div class="separator mb20 mt20"></div>

					<div class="flex mb20 align-center">

						<div class="f18 flex-fill">Datos de PedidosYa Courier</div>

						<i v-if="canOptions && t.custom_data.pedidosya_courier" class="options icon-dots-vertical" @click="Options([
							{text: 'Ver Detalles de Envío', function: () => {ShowPyaCourierLog()}, if: Auth.role.indexOf('admin') > -1, icon: 'information'},
							{text: 'Ver PIN', function: () => {ShowPyaCourierPIN()}, icon: 'information'},
							{text: 'Abrir Soporte', function: () => { Util.Open(t.custom_data.pedidosya_courier.onlineSupportUrl) }, icon: 'external' },
							{text: 'Seguir Envío', function: () => { Util.Open(t.custom_data.pedidosya_courier.shareLocationUrl) }, if: t.custom_data.pedidosya_courier.shareLocationUrl, icon: 'external' },
						])"></i>
					</div>

					<div v-if="t.custom_data.pedidosya_courier">
						<div class="hdvm mb15">
							<div>
								<div class="bold">N° Referencia </div>
								<div>{{t.custom_data.pedidosya_courier.referenceId}}</div>
							</div>
							
							<div>
								<div class="bold">Código de confirmación </div>
								<div>{{t.custom_data.pedidosya_courier.confirmationCode}}</div>
							</div>
						</div>
						
						<div class="hdvm mb15">
							<div>
								<div class="bold">Recolección</div>
								<div>{{Util.Date(t.custom_data.pedidosya_courier.pickupTime, 'HH:mm DD/MM/YYYY')}}</div>
							</div>

							<div>
								<div class="bold">Entrega</div>
								<div>{{Util.Date(t.custom_data.pedidosya_courier.deliveryTime, 'HH:mm DD/MM/YYYY')}}</div>
							</div>
						</div>

						<div class="">
							<div class="bold">Estado </div>
							<div>{{Util.StatusOrderPya[t.custom_data.pedidosya_courier.status]}}</div>
							<div class="secondary-text" v-if="t.custom_data.pedidosya_courier.cancelReason">{{ t.custom_data.pedidosya_courier.cancelReason }}</div>
						</div>
					</div>

					<div v-if="t.custom_data.pedidosya_status">
						<div v-if="t.custom_data.pedidosya_status.reason" class="hdvm mb15">
							<div>
								<div class="bold">Motivo</div>
								<div>{{t.custom_data.pedidosya_status.reason}}</div>
							</div>
						</div>

						<div class="">
							<div class="bold">Estado </div>
							<div>{{Util.StatusOrderPya[t.custom_data.pedidosya_status.status]}}</div>
						</div>
					</div>

				</div>

				<div class="revision-info" v-if="t.custom_data.getnet && t.custom_data.getnet.order">
					<div class="separator mb20 mt20"></div>

					<div class="flex mb20 align-center">
						<div class="f18 flex-fill">Datos de Pago - Getnet</div>
					</div>

					<div v-if="t.custom_data.getnet">
						<div class="hdvm mb15">
							<div>
								<div class="bold">Código de referencia </div>
								<div>{{t.custom_data.getnet.order}}</div>
							</div>
						</div>
						
						<div class="hdvm mb15">
							<div>
								<div class="bold">Últimos dígitos de la tarjeta</div>
								<div>{{ (t.custom_data.getnet.card_number || '').toString().slice(-4) }}</div>
							</div>

							<div>
								<div class="bold">Tipo de tarjeta</div>
								<div>{{ t.custom_data.getnet.payment_type }}</div>
							</div>
						</div>

						<div class="hdvm mb15">
							<!-- <div>
								<div class="bold">Monto</div>
								<div>{{ t.custom_data.getnet.amount }}</div>
							</div> -->

							<div v-if="t.custom_data.getnet.installments">
								<div class="bold">Cuotas</div>
								<div>{{ t.custom_data.getnet.installments }}</div>
							</div>
						</div>
					</div>
				</div>

				<div class="revision-info" v-if="t.custom_data.mercado_pago && t.custom_data.mercado_pago.order">
					<div class="separator mb20 mt20"></div>

					<div class="flex mb20 align-center">
						<div class="f18 flex-fill">Datos de Pago - Mercado Pago</div>
					</div>

					<div v-if="t.custom_data.mercado_pago">
						<div class="hdvm mb15">
							<div>
								<div class="bold">Código de referencia </div>
								<div>{{t.custom_data.mercado_pago.order}}</div>
							</div>
						</div>
						
						<div class="hdvm mb15">
							<div>
								<div class="bold">Últimos dígitos de la tarjeta</div>
								<div>{{ (t.custom_data.mercado_pago.card_number || '').toString().slice(-4) }}</div>
							</div>

							<div>
								<div class="bold">Tipo de tarjeta</div>
								<div>{{ t.custom_data.mercado_pago.payment_type }}</div>
							</div>
						</div>

						<div class="hdvm mb15">
							<!-- <div>
								<div class="bold">Monto</div>
								<div>{{ t.custom_data.mercado_pago.amount }}</div>
							</div> -->

							<div v-if="t.custom_data.mercado_pago.installments">
								<div class="bold">Cuotas</div>
								<div>{{ t.custom_data.mercado_pago.installments }}</div>
							</div>
						</div>
					</div>
				</div>

				<!-- items -->
				<div class="">

					<div class="separator mb20 mt20"></div>

					<div class="flex align-center mb20">
						<div class="flex-fill">
							<div class="f18">Pedido</div>
						</div>
						<button class="secondary" @click="getRevisionOrder(t)" v-if="t.edit_at && Auth.role.indexOf('admin') > -1" v-show="previews.length == 1">Ver Ediciones</button>
					</div>

					<div class="well mb10 revision-info" 
					v-for="(order, index) in t.orders"
					:key="index">
						<div class="order-item relative">
							<div v-if="!order.type">{{Util.Number(order.quantity)}}</div>
							<div v-if="order.type == 'DELIVERY'"><i class="icon icon-delivery c3"></i></div>
							<div v-if="order.type == 'LEY_REDONDEO'"><i class="icon icon-receipt c3"></i></div>
							<div><span>{{order.title}} <span class="secondary-text" v-if="order.external">(Externo)</span></span> <!--<span class="secondary-text">({{Util.Price(order.price*order.quantity)}})</span>-->
								<div class="secondary-text" v-if="order.method">{{Util.PayMethod(order.method)}}</div>
								<ul>
									<li :class="modifier.type" v-for="(modifier, index) in Util.ModifiersList(order, DictTagDinerName(order.diner))" :key="index">
										<span v-html="modifier.value"></span>
										<span class="tag-total-modifiers" v-if="modifier.count > 1">{{modifier.count}}</span>
										<span class="secondary-text" v-if="modifier.price">
											{{Util.Price(modifier.price*order.quantity)}}
										</span>
									</li>
									<!-- <li class="order-comment" v-if="order.comment">{{order.comment}}</li> -->
								</ul>
							</div>
							<div>
								<i v-if="order.paid_at" title="Pagado" style="color: var(--green); " class="icon icon-bill mr5"></i>
								<i v-else-if="order.delivered" title="Entregado" style="color: var(--blue-2); " class="icon icon-tray mr5"></i>
								<i v-else-if="order.prepared" title="Preparado" style="color: var(--yellow); " class="icon icon-chef mr5"></i>
								<i v-if="order.original_price && order.original_price != order.price" class="icon icon-circle-exclamation cyellow" title="Precio modificado"></i> 
								{{Util.Price(order.total_money)}}
							</div>
						</div>
					</div>
					<div class="well mb10 revision-info" v-if="t.comment">
						<div class="bold">Comentario</div>
						<div>{{t.comment}}</div>
					</div>

					<div class="mt20 mb10 flex revision-info" v-if="t.total_discount">
						<div class="bold flex-fill">Subtotal</div>
						<div class="bold">{{Util.Price(t.total_money + t.total_discount)}}</div>
					</div>
					<div class="mb10 flex revision-info" v-if="t.total_discount">
						<div class="flex column unshrink flex-fill">
							<div class="bold">Descuentos</div>
							<div class="mb5"
							v-for="(discount, indexDiscount) in t.discounts"
							:key="indexDiscount"><i class="icon icon-arrow-right"></i> {{discount.title}}<span class="secondary-text ml5">(-{{Util.Price(discount.discount)}})</span></div>
						</div>
						<div class="bold">-{{Util.Price(t.total_discount)}}</div>
					</div>
					<div :class="`f18 flex ${t.status == 'CANCELLED' ? 'cred' : 'cgreen'} revision-info`">
						<div class="bold flex-fill">Total</div>
						<div class="bold">{{Util.Price(t.total_money)}}</div>
					</div>
				</div>
				<!-- metodos de pago -->

				<div class="" v-if="t.custom_data.tips && t.custom_data.tips.length">

					<div class="separator mb20 mt20"></div>

					<div class="f18 mb20">Propinas</div>

					<div>
						<div class="entry flex revision-info" v-for="(tip, indexTip) in t.custom_data.tips" :key="'tip'+indexTip">
							<div class="flex-fill">{{Util.PayMethod(tip.method)}} <span class="secondary-text" v-if="tip.index !== null">(Método {{tip.index+1}})</span></div>
							<div class="bold">{{Util.Price(tip.total)}}</div>
						</div>
					</div>
					<div class="mt20 flex revision-info">
						<div class="flex-fill bold">Total con propinas</div>
						<div class="bold">{{Util.Price(t.total_money + Util.Sum(t.custom_data.tips, 'total'))}}</div>
					</div>
				</div>

				<div class="">

					<div class="separator mb20 mt20"></div>

					<div class="flex align-center mb20 revision-info">
						<div class="flex-fill">
							<div class="f18">Métodos de Pago</div>
							<div class="secondary-text"><span v-if="t.payment.length > 1">Pago dividido</span></div>
						</div>
						<i class="options icon-dots-vertical" v-if="PaymentOptions().length" @click="Options(PaymentOptions())"></i>
					</div>
				

					<div class="mb20">
						<div v-for="(method, index2) in t.payment"
						:key="index2"
						class="entry revision-info">
							<div class="flex">
								<div class="flex column flex-fill">
									<div class="flex-fill mr10">{{Util.PayMethod(method.method)}}</div>
									<div class="flex-fill mr10 secondary-text" v-if="method.method != 'CASH' && method.n_transfer">N° {{ method.n_transfer }}</div>
									<div style="font-size: 12px" class="cgreen" v-if="method.paid_at">Marcado como pagado <span v-if="method.paid_by">por {{ method.paid_by }}</span> el {{Util.Date(method.paid_at, 'HH:mm DD/MM/YYYY')}} <i class="icon icon-check"></i></div>
									<div class="secondary-text" v-if="method.method == 'ONLINE' && t.custom_data.transbank">Pago Online: {{Util.TransbankPaymentType(t.custom_data.transbank.payment_type)}}</div>
									<div class="secondary-text" v-if="Util.MethodTip(t, index2)">
										<div v-if="method.diner"><span class="bold">Comensal: </span>{{ DictTagDinerName(method.diner) }}</div>
										<div><span class="bold">Subtotal: </span>{{Util.Price(method.subtotal)}}</div>
										<div><span class="bold">Propina: </span>{{Util.Price(Util.MethodTip(t, index2))}}</div>
									</div>
									<div class="flex align-center">
										<div v-if="Util.MethodChange(t, method, index2)" class="secondary-text"><span class="bold">Se paga con: </span>{{Util.Price(method.cash)}}</div>
										<div v-if="Util.MethodChange(t, method, index2)" class="secondary-text"> <i class="icon icon-arrow-right ml5 mr5"></i> <span class="bold">Vuelto: </span> {{Util.Price(Util.MethodChange(t, method, index2))}}</div>
									</div>
								</div>
								
								<div class="bold">{{Util.Price(Util.MethodTip(t, index2) + method.subtotal)}}</div>
								
							</div>
						</div>
					</div>

					<div class="well cgreen mb15 revision-info" v-if="t.paid_at">
						<div class="bold">Pedido pagado <span v-if="t.custom_data.paid_by">por {{t.custom_data.paid_by}}</span></div>
						<div>{{Util.Date(t.paid_at, 'HH:mm DD/MM/YYYY')}}</div>
					</div>
					
					<div class="well cyellow mb15 revision-info" v-if="t.pending_payment">
						<div>El pago de esta transacción está pendiente.</div>
					</div>
					<div class="well cred mb15 revision-info" v-if="t.custom_data.refund_at">
						<div class="bold">Pago Reembolsado</div>
						<div>El {{Util.Date(t.custom_data.refund_at, 'LLLL')}} por {{t.custom_data.refund_by}}</div>
					</div>
					<div class="well mb15" v-if="t.custom_data.id_flow">
						<div class="bold">Número Orden Flow</div>
						<div>{{t.custom_data.id_flow}}</div>
					</div>
					<div class="well" v-if="t.custom_data.id_refund">
						<div class="bold">Número Orden Reembolso Flow</div>
						<div>{{t.custom_data.id_refund}}</div>
					</div>
					<div class="well revision-info" v-if="t.custom_data.transbank_pos">
						<div class="bold">Transacción Transbank POS</div>
						<div>Número Operación: {{t.custom_data.transbank_pos.operationNumber}}</div>
						<div>Ticket: {{t.custom_data.transbank_pos.ticket}}</div>
						<div>Comercio: {{t.custom_data.transbank_pos.commerceCode}}</div>
						<div>Terminal: {{t.custom_data.transbank_pos.terminalId}}</div>
						<div>Código Autorización: {{t.custom_data.transbank_pos.authorizationCode}}</div>
						<div>Tarjeta {{ t.custom_data.transbank_pos.cardType }}: **** **** **** {{t.custom_data.transbank_pos.last4Digits}}</div>
					</div>

				</div>
			</div>

		</div>
	</div>

</modal>

<modal v-model="modalRevisionTransaction" dir="right" :modalClass="['fill', 'right md h100']" title="Registro de Edición" hideActions>
	<div class="pa20">
		<div v-for="(revision, index) in modalRevisionTransaction" :key="index">
			<div class="mb20" v-if="revision.length > 0">
				<div class="flex">
					<div class="flex-fill">
						<div class="f18">{{index.split('-')[0]}} - {{index.split('-')[1]}}</div>
						<div class="secondary-text mb15">{{Util.Date(parseInt(index.split('-')[2]), 'HH:mm DD/MM/YYYY')}} <span v-if="index.split('-').length >= 4 && index.split('-')[3]">({{Util.TransactionRevisionsEvents[index.split('-')[3]]}})</span></div>
					</div>
				</div>
				<div class="well mb10" 
				v-for="(itemRevision, indexItem) in revision"
				:key="indexItem">
					<div class="order-item">
						<div :class="`bold ${itemRevision.quantity > 0 ? 'cgreen' : 'cred'}`">
							<span v-if="itemRevision.quantity > 0">
								+
							</span>
							{{Util.Number(itemRevision.quantity)}}
						</div>
						<div class="flex-fill">{{itemRevision.title}} 
                            <ul class="secondary-text">
								<li :class="modifier.type" v-for="(modifier, indexMod) in Util.ModifiersList(itemRevision)" :key="indexMod">{{modifier.value}}</li>
                            </ul>
                        </div>
					</div>
				</div>
			</div>
		</div>
	</div>
</modal>

<modal v-model="modalEditPayment" dir="center" modalClass="sm" title="Editar Método de Pago">
	<div v-if="modalEditPayment" class="pa20">
        <order-form
        v-model="modalEditPayment.orders"
        ref="order"
		:settings="settings"
        :hideSaleType="true"
        :hideCustomer="true"
        :hideComment="true"
        :hideActions="true"
		:hideItems="true"
		:hideDiscount="true"
		:fromTransaction="modalEditPayment.transaction"
		:canEditDeliveryCost="false">
        </order-form>
    </div>
    
	<button class="primary error-color" slot="actions" @click="Confirm({
		text: 'Editar',
		class: 'selected-color',
		title: '¿Editar transacción?',
		input: 'Comentario',
		function: EditPaymentMethod
	})">Editar</button>
    
</modal>

<modal v-model="modalPayPending" dir="center" modalClass="sm" title="Pagar Pago Pendiente">
	<div class="section" v-if="modalPayPending">
		<div class="secondary-text mb10">Seleccione el método de pago con el cual se liquidó la transacción.</div>
		
		<div class="well flex mb10">
			<div class="bold flex-fill">Total</div>	
			<div>{{Util.Price(modalPayPending.total)}}</div>
		</div>
		
		<input-select
		:items="modalPayPending.methods"
		v-model="modalPayPending.pay_method"
		label="Método">
		</input-select>
		
	</div>
	
	<button class="primary purple" slot="actions" @click="Confirm({
		text: 'Liquidar',
		title: 'Se quitará esta transacción de Pagos Pendientes y se cambiará el método de pago al seleccionado ¿Liquidar el pago pendiente de esta transacción?',
		class: 'selected-color',
		function: () => {PayPendingPayment()}
	})">Liquidar Pago</button>
	
</modal>

<modal v-model="modalSendBoleta" dir="center" modalClass="sm" title="Enviar Boleta Electrónica">
	<div class="pa20" v-if="modalSendBoleta">
		<input-field class="mb20"
		v-model="modalSendBoleta.email"
		label="Email">
			<button slot="after" class="primary purple" @click="SendBoletaEmail()">Enviar</button>
		</input-field>

		<input-field
		v-model="modalSendBoleta.phone"
		label="Teléfono">
			<button slot="after" class="primary purple" @click="Util.OpenWhatsapp(modalSendBoleta.phone, modalSendBoleta.shareUrl, {'{name}': transaction.customer.name})">Enviar</button>
		</input-field>
	</div>
	
	<button slot="actions" class="secondary" @click="Reprint(transaction, 'BOLETA');">Imprimir</button>
	<button slot="actions" class="secondary" @click="DownloadBoleta()">Descargar</button>
	
</modal>

<modal v-model="modalSendVirtualVoucher" dir="center" modalClass="sm" title="Voucher Digital">
	<div class="pa20" v-if="modalSendVirtualVoucher">

		<div class="ta-center mb20">
			<img :src="modalSendVirtualVoucher.url" style="max-height: 200px">
		</div>

		<input-field
		v-model="modalSendVirtualVoucher.phone"
		label="Teléfono">
			<button class="primary" slot="after" @click="Util.OpenWhatsapp(modalSendVirtualVoucher.phone, modalSendVirtualVoucher.message, {'{name}': transaction.customer.name})">Enviar</button>
		</input-field>
	</div>
	
	<button slot="actions" class="secondary" @click="Util.Open(modalSendVirtualVoucher.shareUrl)">Abrir</button>
	<button slot="actions" class="secondary" @click="Util.Clipboard(modalSendVirtualVoucher.shareUrl)">Copiar Enlace</button>
	
</modal>

<modal v-model="modalSendBankData" dir="center" modalClass="sm" title="Datos Bancarios">
	
	<div class="pa20" v-if="modalSendBankData">

		<div class="well mb20 secondary-text">
			<div><span class="bold">Nombre: </span>{{modalSendBankData.name}}</div>
			<div><span class="bold">RUT: </span>{{modalSendBankData.rut}}</div>
			<div><span class="bold">Banco: </span>{{modalSendBankData.bank}}</div>
			<div><span class="bold">Cuenta: </span>{{modalSendBankData.account}}</div>
			<div><span class="bold">Número Cuenta: </span>{{modalSendBankData.account_number}}</div>
			<div><span class="bold">Email: </span>{{modalSendBankData.email}}</div>
		</div>

		<input-field
		v-model="modalSendBankData.phone"
		label="Teléfono">
			<button class="primary" slot="after" @click="Util.OpenWhatsapp(modalSendBankData.phone, `${modalSendBankData.name}\n${modalSendBankData.rut}\n${modalSendBankData.bank}\n${modalSendBankData.account}\n${modalSendBankData.account_number}\n${modalSendBankData.email}`);">Enviar</button>
		</input-field>
	</div>

	<button class="secondary" slot="actions" @click="Util.Clipboard(`Nombre: ${modalSendBankData.name}\nRUT: ${modalSendBankData.rut}\nBanco: ${modalSendBankData.bank}\nCuenta: ${modalSendBankData.account}\nNúmero Cuenta: ${modalSendBankData.account_number}\nEmail: ${modalSendBankData.email}`)">Copiar</button>

</modal>

<modal v-model="modalSendOnlinePaymentLink" dir="center" modalClass="sm" title="Pago Online">
	<div class="pa20" v-if="modalSendOnlinePaymentLink">

		<div class="ta-center mb20">
			<img :src="`${Util.backend}qr/${modalSendOnlinePaymentLink.paymentUrl.replace(/\//g, '|')}`" style="max-height: 200px">
		</div>

		<input-field
		v-model="modalSendOnlinePaymentLink.phone"
		label="Teléfono">
			<button class="primary" slot="after" @click="Util.OpenWhatsapp(modalSendOnlinePaymentLink.phone, modalSendOnlinePaymentLink.paymentUrl)">Enviar</button>
		</input-field>
	</div>
	
	<button v-if="modalSendOnlinePaymentLink" slot="actions" class="secondary" @click="Util.Open(modalSendOnlinePaymentLink.paymentUrl)">Abrir</button>
	<button v-if="modalSendOnlinePaymentLink" slot="actions" class="secondary" @click="Util.NotifyService('print', {data: [{qr: modalSendOnlinePaymentLink.paymentUrl}], id: Math.random().toString()});">Imprimir</button>
	<button v-if="modalSendOnlinePaymentLink" slot="actions" class="secondary" @click="Util.Clipboard(modalSendOnlinePaymentLink.paymentUrl)">Copiar Enlace</button>
	
</modal>

<modal v-model="modalCancel" :dir="['right', 'center']" :modalClass="['fill', 'sm']" title="Cancelar Pedido">
    <div class="section" v-if="modalCancel">
        <div class="bold mb10">Mótivo</div>
        <label class="mb10"
        v-for="(reason, index) in modalCancel.reasons"
        :key="index">
            <input type="radio" name="reason" :value="reason.value" v-model="modalCancel.reason"> {{reason.text}} <div class="radio"></div>
        </label>
        <input-field v-model="modalCancel.message" placeholder="Motivo" v-show="modalCancel.reason == 'CUSTOM' || modalCancel.reason == 'OTHER'"></input-field>

		<div class="bold mt15 mb10">Inventario</div>
		<label class="mb10">
			<input type="radio" name="inventory" :value="false" v-model="modalCancel.reduce_inventory"> No afectar inventario <div class="radio"></div>
		</label>
		<label class="cred">
			<input type="radio" name="inventory" :value="true" v-model="modalCancel.reduce_inventory"> Afectar inventario <div class="radio"></div>
		</label>

		<!--
		<div class="" v-if="modalCancel && transaction.payment[0].method == 'ONLINE'">
			<div class="bold mt15 mb10">Pago Online</div>
			<label class="mb10">
				<input type="radio" name="payment" :value="true" v-model="modalCancel.refund"> Con reembolso <div class="radio"></div>
			</label>
			<label class="cred">
				<input type="radio" name="payment" :value="false" v-model="modalCancel.refund"> Sin reembolso <div class="radio"></div>
			</label>
		</div>
		-->
        
	</div>

	<button class="primary error-color" v-if="modalCancel" slot="actions"
	@click="Confirm({
	text: 'Cancelar Pedido', 
	class: 'error-color', 
	cancel: false,
	title: `¿Cancelar pedido #${Util.Zeropad(transaction.id_ticket, 10)} ${modalCancel.reduce_inventory ? '(Afectar el inventario)' : '(No afectar el inventario)'} ${transaction.payment[0].method == 'ONLINE' ? (modalCancel.refund ? '(Con reembolso del pago online)' : '(Sin reembolso del pago online)') : ''}?`,
	function: () => {CancelTransaction()}})">Cancelar Pedido</button>

</modal>

<modal v-model="modalDelivery" :dir="['right', 'center']" :modalClass="['fill', 'sm']" :title="deliveryModalTitle">
    
	<div class="section" v-if="modalDelivery">
        <label class="mb10"
        v-for="(account, index) in accounts"
        :key="index"
        @click="$set(modalDelivery, 'account', account)">
            <input type="radio" name="delivery" :value="account" :checked="modalDelivery.account && account.id==modalDelivery.account.id"> <span class="secondary-text ml5" v-if="modalDelivery.previousAccount && account.id == modalDelivery.previousAccount.id"> (repartidor actual)</span> {{account.display_name}} <div class="radio"></div>
        </label>
    </div>

	<button class="primary error-color" slot="actions"
	v-if="Local.modules.module_pya_courier && modalDelivery && transaction && pedidosYaCourierEnabled && !(modalDelivery.bulkTickets && modalDelivery.bulkTickets.length) && this.modalDelivery.mode !== 'assign'"
	@click="openModalPya()">
		<i class="icon icon-pedidosya mr10"></i>
		<span>PedidosYa Courier</span>
	</button>
    
	<button class="primary purple" slot="actions"
	v-if="modalDelivery && (transaction || (modalDelivery.bulkTickets && modalDelivery.bulkTickets.length))"
	:disabled="(modalDelivery.edit || modalDelivery.mode === 'assign') && modalDelivery.previousAccount && modalDelivery.account && modalDelivery.previousAccount && modalDelivery.account.id == modalDelivery.previousAccount.id" @click="ConfirmDeliveryAction()">{{ modalDelivery.mode === 'assign' ? (modalDelivery.previousAccount ? 'Cambiar Repartidor' : 'Asignar Repartidor') : (modalDelivery.edit ? 'Cambiar Repartidor' : 'Enviar Pedido') }}</button>
    
</modal>

<modal v-model="modalComplete" :dir="['right', 'center']" :modalClass="['fill', 'sm']" title="Entregar Pedido">
    <div v-if="modalComplete" class="pa20">
        <order-form
        v-model="modalComplete.orders"
        ref="orderComplete"
		:settings="settings"
        :hideSaleType="true"
        :hideCustomer="true"
        :hideComment="true"
        :hideActions="true"
		:hideItems="true"
		:hidePayments="false"
		:hideDiscount="true"
		:hideAddTip="true"
		:fromTransaction="transaction"
		:canEditPayment="!!(this.Auth.role.indexOf('admin') > -1 || this.Auth.restrictions.edit_transactions_payment)">
        </order-form>
    </div>
    
	<button slot="actions" class="secondary" @click="$refs.orderComplete.OpenTip()">Agregar Propina</button>
	<button slot="actions" class="primary purple" @click="CompleteTransaction()">Entregar Pedido</button>
    
</modal>

<modal v-model="modalTicket" dir="center" modalClass="sm" :title="transaction?('#'+Util.Zeropad(transaction.id_ticket, 10)):''">
	<i slot="options" class="options icon-dots-vertical" @click="Options(PaymentOptions().concat([{text: 'Generar Voucher Digital', function: () => {ViewDigitalVoucher(transaction)}, icon: 'webpage'}, ...(transaction.customer && transaction.customer.phone ? [{text: 'Enviar Mensaje por Defecto (Whatsapp)', function: () => {SendWspMessageOrderOnline()}, icon: 'whatsapp'}] : [] )]))
	"></i>
    <div v-if="modalTicket" class="flex column pa20">
        <!--<div class="f18 bold ta-center">{{this.Local.name}}</div>-->
        <!--<div class="secondary-text ta-center">#{{Util.Zeropad(modalTicket.id_ticket, 10)}}</div>-->
        <!--<div class="separator mt10 mb10"></div>-->
        <div class="flex column ofy">
            <div class="order-item mb5" style="align-items: flex-start"
            v-for="(item, index) in transaction.orders"
            :key="index">
                <div v-if="!item.type">{{Util.Number(item.quantity)}}</div>
                <div v-if="item.type == 'DELIVERY'"><i class="icon icon-delivery c3"></i></div>
                <div v-if="item.type == 'LEY_REDONDEO'"><i class="icon icon-receipt c3"></i></div>
                <div>
                    <div>{{item.title}}</div>
                    <ul>
                        <li :class="modifier.type" v-for="(modifier, indexMod) in Util.ModifiersList(item)" :key="indexMod">{{modifier.value}}</li>
                    </ul>
                </div>
                <div>{{Util.Price(item.total_money)}}</div>
            </div>
        </div>
        <div class="separator mb10 mt10"></div>
        <div class="flex" v-if="transaction.total_discount > 0">
            <div class="flex-fill">Subtotal</div>
            <div>{{Util.Price(transaction.total_discount + transaction.total_money)}}</div>
        </div>
        <div class="flex" v-if="transaction.total_discount > 0">
            <div class="flex-fill">Descuento</div>
            <div>- {{Util.Price(transaction.total_discount)}}</div>
        </div>
		<div class="flex" v-if="transaction.custom_data && transaction.custom_data.tips && transaction.custom_data.tips.length">
            <div class="flex-fill">Propina</div>
            <div>{{Util.Price(transaction.custom_data.tips.reduce((sum, tip) => sum + (Number(tip.total) || 0), 0))}}</div>
        </div>
        <div class="flex mt10">
            <div class="flex-fill bold">Total</div>
            <div class="bold">{{Util.Price(transaction.total_money)}}</div>
        </div>
		<div class="flex mb10" v-if="transaction.custom_data && transaction.custom_data.tips && transaction.custom_data.tips.length">
            <div class="flex-fill bold">Total con Propina</div>
            <div class="bold">{{Util.Price(getTotalWithTips(transaction))}}</div>
        </div>
		<div class="flex mb10" v-if="shouldShowChange(transaction)">
			<div class="flex-fill bold">Vuelto</div>
            <div class="bold">{{Util.Price(totalChange(transaction))}}</div>
        </div>
        <!--<div v-if="modalTicket.custom_data.influye_code" class="secondary-text ta-center mb5">Código Influye: {{modalTicket.custom_data.influye_code}}</div>-->
        
    </div>
    <button slot="actions" class="secondary" v-if="modalTicket && !transaction.id_boleta && !!Local.modules.module_sii_boleta && !transaction.id_factura" @click="Confirm({
            title: '¿Emitir e imprimir boleta electrónica?',
            text: 'Emitir',
            class: 'selected-color',
            function: () => {SendBoleta()}
    })">Emitir Boleta</button>
    <button slot="actions" class="secondary" v-if="modalTicket && !!Local.modules.module_sii_boleta && !!transaction.id_boleta" @click="OpenModalSendBoleta()">Enviar Boleta</button>
	<button slot="actions" class="secondary" v-if="modalTicket && !transaction.id_factura && !!Local.modules.module_sii_factura && !transaction.id_boleta && (Auth.role.indexOf('admin') > -1 || !!Auth.restrictions.can_create_facturas)" @click="Confirm({
            title: '¿Emitir factura electrónica?',
            text: 'Emitir',
            class: 'selected-color',
            function: () => {SendFactura()}
    })">Emitir Factura</button>
    <button slot="actions" class="secondary" v-if="modalTicket && Local.modules.module_sii_factura && !!transaction.id_factura" @click="OpenmodalSendDte()">Enviar Factura</button>
    <button slot="actions" class="secondary" v-if="!!Local.modules.module_service"
    @click="Options([
		{text: 'Imprimir Boleta Electrónica', function: () => {Reprint(transaction, 'BOLETA')}, if: !!transaction.id_boleta, icon: 'boleta-print'},
		{text: 'Imprimir Voucher', function: () => {Reprint(transaction, 'DEFAULT')}, if: !!Local.modules.module_service, icon: 'customer-print'},
		{text: 'Imprimir para Cocina', function: () => {Reprint(transaction, 'PENDING')}, if: !!Local.modules.module_service, icon: 'kitchen-print'},
		{text: 'Imprimir para Delivery', function: () => {Reprint(transaction, 'DELIVERY')}, if: !!Local.modules.module_service, icon: 'delivery-print'},
		{text: 'Imprimir Todos', function: () => {Reprint(transaction)}, if: !!Local.modules.module_service, icon: 'multiple-print'},
	])">Imprimir</button>
</modal>

<!-- Moda para confirmación de eliminacion de transacción -->
<modal v-model="modalConfirmDeleteTransaction.show" modalClass="sm">	
	<div class="pa20">
		<div class="ta-center mb20" v-html="'Eliminar Transacción'"></div>
		<label class="mb10">
			<input type="radio" name="inventory" :value="false" v-model="modalConfirmDeleteTransaction.rollback"> No afectar inventario <div class="radio"></div>
		</label>
		<label class="cred">
			<input type="radio" name="inventory" :value="true" v-model="modalConfirmDeleteTransaction.rollback"> Afectar inventario <div class="radio"></div>
		</label>
	</div>
	<button slot="actions" @click="modalConfirmDeleteTransaction.show = false" class="secondary">Cancelar</button>
	<button slot="actions" class="primary error-color" @click="DeleteTransaction()">Eliminar transacción</button>
</modal>
<!-- Moda para confirmación de eliminacion de transacción -->

<modal-estimate-pya ref="estimatePya" :order="this.transaction"></modal-estimate-pya>

<modal-factura-electronica ref="facturaElectronica" @generateDte="SentFactura($event)" :order="this.transaction"></modal-factura-electronica>

<transaction-edit ref="transactionEdit" 
@OnTransactionEdit="EditItems($event)"
@OnChangePlatform="$emit('OnChangePlatform')"
:menu="menu"
:overwrites="overwrites"
:inventory="inventory"
:timestamp="timestamp"
></transaction-edit>

<modal v-model="modalEdit" dir="right" :modalClass="['fill', 'xl right h100']" :title="modalEdit ? `Editar ${'#'+Util.Zeropad(modalEdit.id_ticket, 10)}` : ''" hideActions>
	<template #options>
		<input-select
		:icon="mobile? 'menu': ''"
		:items="getPlatformItems()"
		v-model="modalEdit.custom_data.platform"
		inputClass="secondary">
		</input-select>
	</template>
    <div class="flex-fill fill relative flex column" v-if="saleData">
        <sales-form ref="salesForm"
        :transaction="modalEdit"
        :menu="saleData.menu" 
        :categories="saleData.categories" 
        :promotions="saleData.promotions" 
        :settings="saleData.settings" 
        :tables="saleData.tables"
        :overwrites="filteredOverwrite"
        :timestamp="timestamp"
        :inventory="inventory"
        @OnTransactionEdit="EditItems($event)"
        @OnOutOfDateTransaction="modalEdit = null; $nextTick(() => {modalEdit = $event})">
        </sales-form>
    </div>
</modal>
</div>
</template>

<script>
export default {
	props: {
		menu: {
			type: Array,
			default: null
		},
		overwrites: {
			type: Array,
			default: null
		},
		inventory: {
			type: [Object, Array], 
			default: null
		},
		timestamp: {
			type: Number,
			default: 0
		},
	},
	data() {
		return {
			modal: null,
			transaction: null,
			modalEditPayment: null,
			methods: null,
			pendingPaymentsMethods: {},
			modalDivide: null,
			methodsFix: false,
			editPaymentCallback: null,
			modalDiscount: false,
			modalPayPending: null,
			modalSendBoleta: null,
			boletaStatus: {
				CREATED: 'Boleta emitida',
				SENT: 'Enviada al SII',
				RECIEVED: 'Recibo confirmado por el SII',
				OK: 'Boleta recibida exitosamente por SII',
				SEND_ERROR: 'Error en el envío',
				RECIEVED_ERROR: 'Error en el recibo',
				FAILED: 'Boleta no fue recibida por el SII',
				CANCELLED_SENT: 'Anulación emitida',
				CANCELLED_RECIEVED: 'Anulación recibida',
				CANCELLED: 'Anulada',
				RETRY_FAILED: 'Error en el envió (reintento fallido)',
				VERIFICATION_FAILED: 'Error en la verificación (reintento fallido)',
			},
			modalCancel: null,
			modalDelivery: null,
			accounts: null,
			revision: null,
			revisions: [],
			settings: null,
			modalComplete: null,
			modalSendVirtualVoucher: null,
			modalTicket: null,
			modalSendBankData: null,
			modalSendOnlinePaymentLink: null,
			modalRevisionTransaction: null,
			pedidosYaCourierEnabled: false,
			modalConfirmDeleteTransaction : {show : false, rollback : false },
			defaultMessages: null,
			modalEdit: null,
			saleData: null,
			hasRevisions: false,
		}
	},
	methods: {
		Open(transaction) {
			this.revision = null;
			this.revisions = [];
			this.hasRevisions = false;
			if(typeof transaction == 'number')
			{
				this.Loading();
				axios.get(`/transaction/${transaction}`).then(res => {
					this.transaction = res.data;
					this.modal = true;
					this.Response(res);
				}).catch(err => {
					this.Response(err);
				});
			}
			else
			{
				this.modal = true;
				this.transaction = transaction;
			}

			if(this.Auth.role.indexOf('admin') > -1)
			{
				axios.get(`/transaction/${typeof transaction == 'number' ? transaction : transaction.id}/revisions/number`).then(res => {
					this.hasRevisions = res.data.count;
				});
			}

			this.GetRevisionsNumber(transaction)
		},
		Close() {
			this.modal = false;
			this.transaction = null;
			this.modalPayPending = null;
			this.modalEditPayment = null;
		},
		UpdateTransaction(transaction)
		{
			if(this.modal && this.transaction && this.transaction.id === transaction.id) this.transaction = transaction;
		},
		OpenItems(transaction)
		{
			this.transaction = transaction;
			this.$refs.transactionEdit.Open(transaction);
		},
		ClickDeleteTransaction(){
			this.modalConfirmDeleteTransaction = { show : true, rollback : true}
		},
		DeleteTransaction() {
			this.$root.$emit('Loading');
			let data = {
				'data' : {
					'rollback' :  this.modalConfirmDeleteTransaction.rollback
				}
			}
			axios.delete(`/transaction/${this.transaction.id}`, data).then(res => {
			this.$root.$emit('Response', res);
			if(!res.data.error)
			{
				this.modal = false;
				this.modalConfirmDeleteTransaction = {show : false, rollback : false }
				this.$emit('OnTransactionDeleted', this.transaction.id);
			}
			}).catch(err => {
				this.$root.$emit('Response', err);
			});
		},
		async OpenEditPayment(transaction, completeCallback) 
		{
			let transactionCopy = this.Util.Copy(transaction);
			this.editPaymentCallback = completeCallback;
			if(!this.settings)
			{
				this.Loading();
				this.settings = (await axios.get(`/methods/${this.Local.id}`)).data;
				this.settings.no_payment_select = false;
				this.Response({});
			}
			this.modalEditPayment = {
				orders: {},
				transaction: transactionCopy
			};
			this.$nextTick(() => {

				var deliveryCost = 0;
				var leyRedondeo = 0;
				transactionCopy.orders.forEach(item => {
                    if(item.type == 'DELIVERY') 
					{
						this.$refs.order.deliveryCost = item.price;
						this.$refs.order.deliveryPaymentMethod = item.method;
						deliveryCost = item.price;
						if(item.external) this.$refs.order.isExternalDelivery = true;
					}
					if(item.type == 'LEY_REDONDEO') leyRedondeo += item.total_money || 0;
                });

				var baseTotal = transactionCopy.total_money - deliveryCost - leyRedondeo;
				this.$set(this.modalEditPayment, 'orders', {
					'ORDER': {
						title: 'Pedido',
						total_money: baseTotal,
						price: baseTotal,
						quantity: 1
					}
				});

				let payments = this.Util.Copy(transactionCopy.payment || []);
				payments.forEach((payment) => {
					if(payment.round != null && payment.round !== '') {
						const round = Number(payment.round);
						payment.round = -round;
						payment.subtotal = (Number(payment.subtotal) || 0) + round;
					}
				});

				setTimeout(() => {
					this.$refs.order.paymentMethods = [];
                    this.$refs.order.sale = transactionCopy.type;
					if(transactionCopy.custom_data.tips) this.$refs.order.tips = transactionCopy.custom_data.tips;
                    this.$nextTick(() => {
						this.$refs.order.paymentMethods = payments;
                    });
				}, 10);
				
			});
		},
		EditPaymentMethod(comment)
		{
			var order = this.$refs.order.GetOrder();
			if(!order) return;
			
			var data = {
				methods: order.payment, 
				edit_comment: comment,
				deliveryPaymentMethod: this.$refs.order.deliveryPaymentMethod,
				tips: order.tips
			};

			this.Loading();
			axios.patch(`/transaction/${this.transaction.id}/methods`, data).then(res => {
				this.Response(res);
				this.transaction = res.data;
				this.$emit('OnTransactionEdit', res.data);
				this.modalEditPayment = null;

				if(this.editPaymentCallback)
				{
					this.editPaymentCallback(res.data);
				}

			}).catch(err => {
				this.Response(err);
			});
		},
		EditItems(transaction)
		{
			this.$emit('OnTransactionEdit', transaction);
			this.transaction = transaction.transaction ? transaction.transaction : transaction;
			this.modalEdit = null;
			this.saleData = null;
			if(this.modal) this.GetRevisionsNumber(this.transaction);
		},
		/*
		Abre el modal de pagos pendientes, se descargan los medios de pagos y se configuran los posibles para liquidar la transacción. 
		Se verfica también el total en caso de pagos pendientes con pagos dividos
		@return Info en caso de que no existen pagos pendientes se muestra mensaje de error
		*/
		async OpenPayPending()
		{
			if(!this.settings)
			{
				this.Loading();
				this.settings = (await axios.get(`/methods/${this.Local.id}`)).data;
				this.Response({});
			}

			var pendingMethods = {};
			var methods = [];
			methods.push({value: 'CASH', text: 'Efectivo'});
			methods.push({value: 'Transferencia', text: 'Transferencia'});
			this.settings.payment_methods.forEach(method => {
				if(!method.pending_payment) methods.push({value: method.title, text: method.title});
				else pendingMethods[method.title] = true;
			});
			
			if(methods.length === 0) return this.Info(`No hay métodos de pago para liquidar esta transacción`);
			
			var method = null;
			for(var i = 0; i < this.transaction.payment.length; i++)
			{
				if(pendingMethods[this.transaction.payment[i].method])
				{
					method = this.transaction.payment[i];
					break;
				}
			}

			if(!method) return this.Info(`No existe el método de pago pendiente o no está configurado como Pago Pendiente`);

			this.modalPayPending = {
				methods: methods,
				pay_method: methods[0].value,
				total: method.subtotal,
				method: method.method
			};

		},
		/*
		Request para liquidar transaccion individual
		@endpoint POST transaction/{id}/pay
		*/
		PayPendingPayment()
		{
			this.Loading();
			axios.post(`/transaction/${this.transaction.id}/pay`, this.modalPayPending).then(res => {
				this.$root.$emit('PendingPaymentPaid', this.modalPayPending.method);
				this.Info(`Transacción liquidada exitosamente`);
				this.modalPayPending = null;
			}).catch(err => {
				this.Response(err);
			});
		},
		/*
		Genera un reembolso por el total de la transacción
		@endpoint GET transaction/{id_transaction}/refund
		*/
		RefundTransaction()
		{
			this.Loading();
			axios.get(`/transaction/${this.transaction.id}/refund`).then(res => {
				this.transaction = res.data;
				this.Info(`Rembolso generado exitosamente`);
			}).catch(err => {
				this.Response(err);
			});
		},
		
		SendBoleta(id)
		{
			this.Loading();
			axios.post(`/transaction/${id ? id : this.transaction.id}/boleta`).then(res => {
				res.data.edit_type = 'BOLETA';
				this.transaction = res.data;
				this.Info(`Boleta emitida exitosamente`);
				this.OpenModalSendBoleta();
				this.$emit('OnTransactionEdit', res.data);
				this.Reprint(this.transaction, 'BOLETA', 'CREATED');

			}).catch(err => {
				this.Response(err);
			});
		},

		ResendBoleta(transaction)
		{
			if(!transaction) transaction = this.transaction;
			this.Loading();
			axios.post(`/transaction/${transaction.id}/boleta/resend`).then(res => {
				this.transaction = res.data;
				this.Info(`Boleta reenviada exitosamente`);
			}).catch(err => {
				this.Response(err);
			});
		},

		ShowBoletaLog(transaction)
		{
			if(!transaction) transaction = this.transaction;
			this.Loading();
			axios.get(`/transaction/${transaction.id}/boleta/log`).then(res => {
				this.Info(res.data.log ? res.data.log : 'No hay datos');
			}).catch(err => {
				this.Response(err);
			});
		},

		async OpenModalSendBoleta(transaction, sendWhatsapp)
		{
			if(!transaction) transaction = this.transaction;
			if(!this.defaultMessages)
			{
				this.Loading();
				this.defaultMessages = {};
				this.defaultMessages = (await axios.get(`/local/${this.Local.id}/messages`)).data;
				this.Response({error: false});
			}
			
			let baseUrl = process.env.NODE_ENV === 'production' ? `https://sii.influye.app` : `${this.Util.backend}boleta/preview`;
			let shareUrl = encodeURIComponent(`${baseUrl}?rut=${transaction.custom_data.boleta.rut}&number=${transaction.custom_data.boleta.folio}&date=${transaction.custom_data.boleta.fecha_corta.replace(/\//g, '-')}&total=${transaction.custom_data.boleta.total.replace(/\./g, '')}`);
			let modalData = {
				email: transaction.customer && transaction.customer.email ? transaction.customer.email : '',
				phone: transaction.customer && transaction.customer.phone ? transaction.customer.phone : '+569',
				shareUrl: this.defaultMessages.default_boleta_message ? `${this.defaultMessages.default_boleta_message}\n${shareUrl}` : shareUrl,
			};
			if(sendWhatsapp)
				this.Util.OpenWhatsapp(modalData.phone, modalData.shareUrl, {'{name}': transaction.customer.name});
			else
				this.modalSendBoleta = modalData;
		},

		sendNotaCredito(){
			this.Loading();
            axios.post(`/sii/nota-credito/${this.Local.id}/create`, this.transaction)
            .then( ({data}) => {
                if(!data.status) return this.Info(data.message);
				if(data.transaction) this.transaction = data.transaction;
				this.OpenmodalSendDte(61);
                return this.Info(data.message);
            })
            .catch( err => {
                this.Response(err);
            });
		},

		SendFactura(){
            this.$refs.facturaElectronica.Open();
		},
		SentFactura(transaction){
			this.transaction = transaction;
		},
		OpenmodalSendDte(type = 33){
            this.$refs.facturaElectronica.OpenmodalSendDte(this.transaction, type);
		},

		async ViewDigitalVoucher(transaction, sendWhatsapp)
		{
			if(!transaction) transaction = this.transaction;
			this.Loading();

			if(!this.defaultMessages) 
			{	
				this.defaultMessages = {};
				this.defaultMessages = (await axios.get(`/local/${this.Local.id}/messages`)).data;
			}

			axios.get(`/transaction/${transaction.id}/voucher`).then(res => {
				var url = this.Util.backend + 'voucher/' + res.data;
				let shareUrl = (process.env.NODE_ENV === 'production' ? `https://voucher.influye.app/` : `${this.Util.backend}voucher/preview/`) + res.data;
				let modalData = {
					url: url, 
					phone: transaction.customer && transaction.customer.phone ? transaction.customer.phone : '+569',
					shareUrl: shareUrl,
					message: this.defaultMessages.default_voucher_message ? `${this.defaultMessages.default_voucher_message}\n${shareUrl}` : shareUrl,
					transaction: transaction,
				};
				if(sendWhatsapp)
					this.Util.OpenWhatsapp(modalData.phone, modalData.message, {'{name}': transaction.customer.name});
				else
					this.modalSendVirtualVoucher = modalData;

				this.Response(res.data);
			}).catch(err => {
				this.Response(err);
			});
		},

		SendDepositData(phone)
		{
			this.Loading();
			axios.get(`/local/${this.Local.id}/bank`).then(res => {
				this.Response(res);
				//this.Util.OpenWhatsapp(phone, `${res.data.name}\n${res.data.rut}\n${res.data.bank}\n${res.data.account}\n${res.data.account_number}\n${res.data.email}`);
				res.data.phone = phone ? phone : '+569';
				this.modalSendBankData = res.data;
				
			}).catch(err => {
				this.Response(err);
			})
		},

		SendBoletaEmail()
		{
			this.Loading();
			axios.post(`/transaction/${this.transaction.id}/boleta/send`, this.modalSendBoleta).then(res => {
				this.Info(`Boleta enviada a ${this.modalSendBoleta.email}`);
				//this.modalSendBoleta = null;
			}).catch(err => {
				this.Response(err);
			});
		},

		DownloadBoleta()
		{
			this.Loading();
            axios.get(`/transaction/${this.transaction.id}/boleta/download`, {
                responseType: 'blob',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/pdf'
                }
            }).then(res => {
                    this.Response(res);
                    this.Util.DownloadFile(res, `dte_39_folio_${this.transaction.custom_data.boleta.folio}.pdf`);
            }).catch(err => {
                this.Response(err);
            });
		},

		OpenCancel(transaction)
		{
			this.transaction = transaction;
			var modal = {reduce_inventory: true, refund: false};
			if(transaction.source == 'UBER_EATS')
			{
				modal.reasons = [
					{text: 'Sin stock (problema con ítems)', value: 'ITEM_ISSUE'},
					{text: 'Cocina cerrada', value: 'KITCHEN_CLOSED'},
					{text: 'Cliente llamó para cancelar', value: 'CUSTOMER_CALLED_TO_CANCEL'},
					{text: 'Restaurant muy ocupado', value: 'RESTAURANT_TOO_BUSY'},
					{text: 'Instrucciones especiales no se pueden cumplir', value: 'SPECIAL_INSTRUCTIONS'},
					{text: 'Otro (escribir el motivo)', value: 'OTHER'}
				];
			}
			else if(transaction.custom_data && transaction.custom_data.integration_pya) {
				modal.reasons = [
					{text: 'Alta demanda', value: 'TOO_BUSY'},
					{text: 'Restaurant cerrado', value: 'CLOSED'},
					{text: 'Problemas para interactuar con pedido', value: 'NO_RESPONSE'},
					{text: 'Inconvenientes con productos', value: 'MENU_ACCOUNT_SETTINGS'},
				];

			} else {
				modal.reasons = [
					{text: 'Cliente no encontrado', value: 'Cliente no encontrado'},
					{text: 'Cliente disconforme', value: 'Cliente disconforme'},
					{text: 'Pedido incorrecto', value: 'Pedido incorrecto'},
					{text: 'Rechazado por demora', value: 'Rechazado por demora'},
					{text: 'Pedido duplicado', value: 'Pedido duplicado'},
					{text: 'Otro (escribir el motivo)', value: 'OTHER'}
				];
			}
			modal.reason = modal.reasons[0].value;
			this.modalCancel = modal;
		},

		/*
        Cancela una transacción entregando un motivo
        @params modalCancel
        @param reason <String> motivo de cancelación
        @param reduce_inventory <Bool> indica si se hará una reduccón de inventario
        @param refund <Bool> [Optional] para IAP con pago online, indica si se hará un reembolso del pago
        */
        CancelTransaction()
        {

            var reason = this.modalCancel.reason == 'CUSTOM' || this.modalCancel.reason == 'OTHER' ? this.modalCancel.message : this.modalCancel.reason;
            if(!reason) return this.Info('Motivo inválido');

            var data = {
                reason: reason,
                reduce_stock: this.modalCancel.reduce_inventory
            };

            if(this.transaction.payment[0].method == 'ONLINE')
            {
                data.refund = this.modalCancel.refund;
            }

            this.Loading();
            axios.post(`/transaction/${this.transaction.id}/cancel`, data).then(res => {
                this.Response(res);
                this.modalCancel = null;
				this.modal = null;
				this.$emit('OnTransactionCanceled', res.data);
            }).catch(err => {
                this.Response(err);
            });
        },

		async OpenComplete(transaction, tip)
		{
			console.log(transaction);
			this.transaction = this.Util.Copy(transaction);
			if(tip)
			{
				if(!this.settings)
				{
					this.Loading();
					this.settings = (await axios.get(`/methods/${this.Local.id}`)).data;
					this.settings.no_payment_select = false;
					this.Response({});
				}
				this.modalComplete = {
					orders: {}
				};
				let deliveryItem = null;
				this.$nextTick(() => {
					
					var total = this.transaction.total_money;
					var delivery = 0;

					deliveryItem = this.transaction.orders.find(el => el.type == 'DELIVERY');
					if(deliveryItem)
					{
						delivery = deliveryItem.total_money;
					}
					total -= delivery;

					let round = 0;
					let roundItem = this.transaction.orders.find(el => el.type == 'LEY_REDONDEO');
					if(roundItem)
					{
						round = roundItem.total_money;
					}
					total -= round;

					this.$set(this.modalComplete, 'orders', {
						'ORDER': {
							title: 'Pedido',
							total_money: total,
							price: total,
							quantity: 1
						}
					});
					if(this.transaction.custom_data.tips) this.$refs.orderComplete.tips = this.transaction.custom_data.tips;
					this.$refs.orderComplete.paymentMethods = [];
					this.$refs.orderComplete.sale = this.transaction.type;
					this.$refs.orderComplete.deliveryCost = delivery;
				});
				
				setTimeout(() => {
					console.log(this.transaction);
					//invertir el round
					let payments = this.Util.Copy(this.transaction.payment);
					payments.forEach((payment) => {
						if (payment.method == 'CASH' && payment.round != null && payment.round !== '') {
							const r = Number(payment.round);
							payment.round = -r;
							payment.subtotal = (Number(payment.subtotal) || 0) + r; 
						}
					});

					this.$nextTick(() => {
						this.$refs.orderComplete.paymentMethods = payments;
						this.$nextTick(() => {
							if(deliveryItem && deliveryItem.method) this.$refs.orderComplete.deliveryPaymentMethod = deliveryItem.method;
						});
						console.log(this.$refs.orderComplete);
					});
				}, 10);

			}
			else
			{
				this.Confirm({
					title: `¿Confirmar que el pedido #${this.Util.Zeropad(transaction.id_ticket, 10)} ha sido entregado?`,
					text: 'Pedido Entregado',
					class: 'selected-color',
					function: () => {this.CompleteTransaction()}
				})
			}
		},

		CompleteTransaction(transaction)
		{
			
			if(transaction) this.transaction = transaction;

			if(!this.modalComplete)
			{
				if(this.transaction.payment.some(method => method.method == 'NO_SELECT'))
					return this.Info(`Debe seleccionar un método de pago.`);
			}

			var completeData = null;
			if(this.modalComplete)
			{
				let orderTransaction = this.$refs.orderComplete.transaction;
				if(typeof orderTransaction == 'string') return this.Info(orderTransaction);

				completeData = {
					tips: this.$refs.orderComplete.tips,
					payment: this.$refs.orderComplete.paymentMethods,
					deliveryPaymentMethod: this.$refs.orderComplete.deliveryPaymentMethod,
					pendingPayment: this.$refs.orderComplete.transaction.pending_payment,
				}
				if(completeData.payment.some(method => method.method == 'NO_SELECT') || completeData.deliveryPaymentMethod == 'NO_SELECT')
					return this.Info(`Debe seleccionar un método de pago.`);
			}

			this.Loading();
            axios.post(`/transaction/${this.transaction.id}/complete`, completeData).then(res => {
                this.Response(res);
                this.$emit('OnTransactionCompleted', res.data);
				this.modalComplete = null;
				if(!this.transaction.paid_at && res.data.paid_at) this.Util.OpenCashDraw(res.data);
            }).catch(err => {
                this.Response(err);
            });
		},

		/*
		abre el modal para despachar un pedido
		*/	
		async OpenDelivery(transaction)
		{
			if(!this.accounts) 
			{
				this.Loading();
				var data = (await axios.get(`/accounts/${this.Local.id}/delivery?v2=true`)).data; 
				this.accounts = data.accounts;
				this.pedidosYaCourierEnabled = data.pya; 
				this.Response({});
			}

			var account = this.accounts.length ? this.accounts[0] : null;
			var previousAccount = null;
			if(transaction.status == 'DELIVERY')
			{
				for(var i = 0; i < this.accounts.length; i++)
				{
					if(this.accounts[i].id == transaction.id_delivery_by)
					{
						account = this.accounts[i];
						previousAccount = this.accounts[i];
						break;
					}
				}
			}
			else if(transaction.status == 'PENDING' && transaction.id_delivery_by)
			{
				for(var j = 0; j < this.accounts.length; j++)
				{
					if(this.accounts[j].id == transaction.id_delivery_by)
					{
						account = this.accounts[j];
						this.transaction = transaction;
						const num = this.Util.Zeropad(transaction.id_ticket, 10);
						this.Confirm({
							text: 'Enviar',
							title: `¿Enviar el pedido #${num} con repartidor ${account.display_name}?`,
							class: 'selected-color',
							function: () => { this.postDeliverSingle(account.id, null); },
						});
						return;
					}
				}
			}

			
			this.transaction = transaction;
			this.modalDelivery = {
				account: account,
				edit: transaction.status == 'DELIVERY',
				previousAccount: previousAccount,
				mode: 'dispatch',
			};
		},

		async OpenAssignDelivery(transaction)
		{
			if(!this.accounts)
			{
				this.Loading();
				var data = (await axios.get(`/accounts/${this.Local.id}/delivery?v2=true`)).data;
				this.accounts = data.accounts;
				this.pedidosYaCourierEnabled = data.pya;
				this.Response({});
			}

			var account = this.accounts.length ? this.accounts[0] : null;
			var previousAccount = null;
			if(transaction.id_delivery_by)
			{
				for(var i = 0; i < this.accounts.length; i++)
				{
					if(this.accounts[i].id == transaction.id_delivery_by)
					{
						account = this.accounts[i];
						previousAccount = this.accounts[i];
						break;
					}
				}
			}

			this.transaction = transaction;
			this.modalDelivery = {
				account: account,
				edit: false,
				previousAccount: previousAccount,
				mode: 'assign',
			};
		},

		async OpenDeliveryBulk(tickets)
		{
			if (!tickets || !tickets.length) return;
			if (!this.accounts)
			{
				this.Loading();
				var data = (await axios.get(`/accounts/${this.Local.id}/delivery?v2=true`)).data;
				this.accounts = data.accounts;
				this.pedidosYaCourierEnabled = data.pya;
				this.Response({});
			}
			var account = this.accounts.length ? this.accounts[0] : null;
			this.transaction = tickets[0];
			this.modalDelivery = {
				account: account,
				edit: false,
				previousAccount: null,
				bulkTickets: tickets,
				mode: 'dispatch',
			};
		},

		ConfirmDeliveryAction()
		{
			if (!this.modalDelivery || !this.modalDelivery.account) return this.Info('Repartidor inválido');
			const bulk = this.modalDelivery.bulkTickets && this.modalDelivery.bulkTickets.length;
			if (bulk)
			{
				this.Confirm({
					text: 'Enviar',
					title: `¿Asignar el envío de ${this.modalDelivery.bulkTickets.length} pedidos a ${this.modalDelivery.account.display_name}?`,
					class: 'selected-color',
					function: () => { this.DeliverTransaction(null); },
				});
				return;
			}
			if (!this.transaction) return;
			if (this.modalDelivery.mode === 'assign')
			{
				const name = this.modalDelivery.account.display_name;
				const TicketNum = this.Util.Zeropad(this.transaction.id_ticket, 10);
				this.Confirm({
					text: this.modalDelivery.previousAccount ? 'Cambiar' : 'Asignar',
					title: this.modalDelivery.previousAccount
						? `¿Cambiar la asignación de repartidor del pedido #${TicketNum} a ${name}? El pedido seguirá sin enviar.`
						: `¿Asignar a ${name} el pedido #${TicketNum} sin enviarlo? Podrás despacharlo después con «Enviar pedido».`,
					class: 'selected-color',
					input: this.modalDelivery.previousAccount ? 'Comentario' : null,
					function: this.AssignDeliveryTransaction,
				});
				return;
			}
			this.Confirm({
				text: this.modalDelivery.edit ? 'Cambiar Repartidor' : 'Enviar',
				title: this.modalDelivery.edit ? `¿Cambiar el repartidor de la transacción #${this.Util.Zeropad(this.transaction.id_ticket, 10)} a ${this.modalDelivery.account.display_name}?` : `¿Asignar el envió de la transacción #${this.Util.Zeropad(this.transaction.id_ticket, 10)} a ${this.modalDelivery.account.display_name}?`,
				class: 'selected-color',
				input: this.modalDelivery.edit ? 'Comentario' : null,
				function: this.DeliverTransaction,
			});
		},

		/*
		despacha la transaccion
		@params modalDelivery
		@param account la cuenta repartidor
		*/
		async DeliverTransaction(comment)
        {
			if(!this.modalDelivery.account) return this.Info('Repartidor inválido');
			const bulk = this.modalDelivery.bulkTickets && this.modalDelivery.bulkTickets.length;
			if (bulk)
			{
				this.Loading();
				const idDelivery = this.modalDelivery.account.id;
				try
				{
					const ids = this.modalDelivery.bulkTickets.map(t => t.id);
					const res = await axios.post(`/transactions/${this.Local.id}/multiple/deliver`, {
						transactions: ids,
						id_delivery: idDelivery,
					});
					this.modalDelivery = null;
					this.Response(res);
					this.$emit('OnBulkDeliveryComplete', res.data.sent || []);
				}
				catch (err)
				{
					this.Response(err);
				}
				return;
			}
			if (!this.transaction) return;
			this.postDeliverSingle(this.modalDelivery.account.id, comment);
        },

		postDeliverSingle(idDelivery, comment)
		{
			if (!this.transaction) return;
			this.Loading();
			axios.post(`/transaction/${this.transaction.id}/deliver`, { id_delivery: idDelivery, edit_comment: comment }).then(res => {
				this.Response(res);
				this.modalDelivery = null;
				this.$emit('OnTransactionDelivery', res.data);
			}).catch(err => {
				this.Response(err);
			});
		},

		AssignDeliveryTransaction(comment)
		{
			if(!this.modalDelivery.account) return this.Info('Repartidor inválido');
			if (!this.transaction) return;
			this.Loading();
			axios.post(`/transaction/${this.transaction.id}/assign-delivery`, { id_delivery: this.modalDelivery.account.id, comment: comment }).then(res => {
				this.Response(res);
				this.modalDelivery = null;
				this.$emit('OnTransactionDelivery', res.data);
			}).catch(err => {
				this.Response(err);
			});
		},

		GetRevision(transaction)
		{
			this.Loading();
			axios.get(`/transaction/${transaction.id}/revision`).then(res => {
				var revisions = [];
				console.log(res.data);
				var index = res.data.length;
				res.data.forEach(rev => {
					revisions.push({
						text: `Edición ${index--} (${this.Util.Date(rev.edit_at, 'HH:mm DD/MM/YYYY')})`,
						value: index,
						data: rev,
					});
				});
				this.revisions = revisions;
				if(res.data.length) this.revision = res.data.length-1;
				this.Response(res);
			}).catch(err => {
				this.Response(err);
			});
		},
		VoucherOptions(transaction)
		{
			this.transaction = transaction;
			let options = [
				{text: 'Imprimir Factura Electrónica', function: () => {this.Util.NotifyService('factura', {data: this.transaction.custom_data.factura, id: Math.random().toString(), id_transaction: this.transaction.id });}, if: !!this.transaction.custom_data.factura, icon: 'factura-print'},
				{text: 'Imprimir Boleta Electrónica', function: () => {this.Reprint(this.transaction, 'BOLETA')}, if: !!this.transaction.id_boleta, icon: 'boleta-print'},
				// {text: 'Imprimir Pre Cuenta', function: () => {this.Util.NotifyService('reprint', {data: this.transaction, id: Math.random().toString(), types: 'PRE'});}, if: !!this.Local.modules.module_service && (this.transaction.type == 'SERVE' && this.transaction.table_name) && (this.Auth.role.indexOf('admin') > -1 || this.Auth.restrictions.reprint_options.includes("precuenta"))},
				{text: 'Imprimir Pre Cuenta', function: () => {this.Reprint(this.transaction,'PRE');}, if: !!this.Local.modules.module_service && (this.transaction.type == 'SERVE' && this.transaction.table_name) && (this.Auth.role.indexOf('admin') > -1 || this.Auth.restrictions.reprint_options.includes("precuenta")), icon: 'table-print'},
				{text: 'Imprimir para Delivery', function: () => {this.Reprint(this.transaction, 'DELIVERY')}, if: !!this.Local.modules.module_service && (this.Auth.role.indexOf('admin') > -1 || this.Auth.restrictions.reprint_options.includes("delivery")), icon: 'delivery-print'},
				{text: `Imprimir para Cocina`, function: () => {this.Reprint(this.transaction, 'PENDING')}, if: !!this.Local.modules.module_service && (this.Auth.role.indexOf('admin') > -1 || this.Auth.restrictions.reprint_options.includes("kitchen")), icon: 'kitchen-print'},
				{text: 'Imprimir Voucher', function: () => {this.Reprint(this.transaction, 'DEFAULT')}, if: !!this.Local.modules.module_service && (this.Auth.role.indexOf('admin') > -1 || this.Auth.restrictions.reprint_options.includes("voucher")), icon: 'customer-print'},
				{text: 'Imprimir Todos', function: () => {this.Reprint(this.transaction)}, if: !!this.Local.modules.module_service && (this.Auth.role.indexOf('admin') > -1 || ['voucher', 'kitchen', 'delivery'].every(value => this.Auth.restrictions.reprint_options.includes(value))), icon: 'multiple-print'},
			];
			this.Options(options);
		},

		async CustomerOptions(transaction, type)
		{
			if(!transaction) transaction = this.transaction;
			//else this.transaction = transaction;
			let options = [];

			if((!type || type == 'PHONE') && transaction.customer && transaction.customer.phone)
				options.push({text: 'Llamar', function: () => {this.Util.Open(`tel:${transaction.customer.phone}`)}, icon: 'phone'});

			if(!type || type == 'ADDRESS')
			{
				if(transaction.customer && transaction.customer.address)
				{
					if(this.mobile) options.push({text: 'Buscar en Waze', function: () => {this.Util.OpenWaze(transaction.customer.address)}, icon: 'waze'});
					options.push({text: 'Buscar en Google Maps', function: () => {this.Util.OpenGoogleMaps(transaction.customer.address)}, icon: 'google-maps'});
				}
				if(transaction.custom_data.longitude) options.push({text: 'Abrir Ubicación en Google Maps', function: () => {this.Util.OpenGoogleMaps(transaction.custom_data)}, icon: 'google-maps'});
			}

			if(!type || type == 'PHONE')
			{
				if(transaction.customer && transaction.customer.phone)
				{
					if(transaction.id_boleta) options.push({text: 'Enviar Boleta Electrónica (Whatsapp)', function: () => {this.OpenModalSendBoleta(transaction, true)}, icon: 'whatsapp'});
					if(transaction.id) options.push({text: 'Enviar Voucher (Whatsapp)', function: () => {this.ViewDigitalVoucher(transaction, true)}, icon: 'whatsapp'});
					if(this.canSendDepositData) options.push({text: 'Enviar Datos de Transferencia (Whatsapp)', function: () => {this.SendDepositData(transaction.customer.phone)}, icon: 'whatsapp'});
					if(!this.defaultMessages) 
					{	
						this.Loading();
						this.defaultMessages = {};
						this.defaultMessages = (await axios.get(`/local/${this.Local.id}/messages`)).data;
						this.Response({error: false});
					}
					console.log(this.defaultMessages);
					if(transaction.type == 'DELIVERY' && this.defaultMessages.default_delivery_message)
						options.push({text: 'Enviar Mensaje por Defecto (Whastapp)', function: () => {this.Util.OpenWhatsapp(transaction.customer.phone, this.defaultMessages.default_delivery_message, {'{name}': transaction.customer.name, '{address}': transaction.customer.address, '{survey}': `https://survey.influye.app/${transaction.code}`})}, icon: 'whatsapp'});
					else if(this.defaultMessages.default_difussion_message)
						options.push({text: 'Enviar Mensaje por Defecto (Whastapp)', function: () => {this.Util.OpenWhatsapp(transaction.customer.phone, this.defaultMessages.default_difussion_message, {'{name}': transaction.customer.name, '{survey}': `https://survey.influye.app/${transaction.code}`})}, icon: 'whatsapp'});
					options.push({text: 'Abrir en Whastapp', function: () => {this.Util.OpenWhatsapp(transaction.customer.phone, '')}, icon: 'whatsapp'});
				}
			}

			this.Options(options);
			
		},

		async DeliveryDriverOptions(transaction)
		{
			console.log("transaction: ", transaction)
			
			if(!transaction || !transaction.custom_data.delivery_phone) return;

			let options = [];
			options.push({text: 'Llamar', function: () => {this.Util.Open(`tel:${transaction.custom_data.delivery_phone}`)}, icon: 'phone'});

			if(!this.defaultMessages)
			{
				this.Loading();
				this.defaultMessages = {};
				this.defaultMessages = (await axios.get(`/local/${this.Local.id}/messages`)).data;
				this.Response({error: false});
			}
		
			let lat = null;
			let lng = null;

			const customer = transaction.customer ? transaction.customer : {};
			const customData = transaction.custom_data ? transaction.custom_data : {};

			if(customer.latitude && customer.longitude){
				lat = customer.latitude;
				lng = customer.longitude;
			}else if(customData.latitude && customData.longitude){
				lat = customData.latitude;
				lng = customData.longitude;
			}

			const gpsLink = (lat != null && lng != null)
				? `https://maps.google.com/?q=${lat},${lng}`
				: '';

			if(this.defaultMessages.default_message_delivery_driver){
				options.push({text: 'Enviar Mensaje por Defecto (WhatsApp)', function: () => {this.Util.OpenWhatsapp(transaction.custom_data.delivery_phone, this.defaultMessages.default_message_delivery_driver, {
					'{ticket}': transaction.id_ticket || transaction.id || '',
					'{name}': transaction.customer.name || '',
					'{phone}': transaction.customer.phone || '',
					'{address}': transaction.customer.address || transaction.custom_data.maps_address ||'',
					'{gps}': gpsLink},
				)}, icon: 'whatsapp'});
			}
			
			options.push({text: 'Abrir en WhatsApp', function: () => {this.Util.OpenWhatsapp(transaction.custom_data.delivery_phone, '')}, icon: 'whatsapp'});

			this.Options(options);
		},

		VirtualVoucherOption(transaction)
		{
			return {
				text: 'Generar Voucher Digital', 
				function: () => {
					this.transaction = transaction;
					this.ViewDigitalVoucher(transaction)
				},
				icon: 'webpage'
			};
		}
		,
		BoletaOption(transaction)
		{
			if(this.Local.modules.module_sii_boleta)
			{
				if(transaction.id_boleta)
				{
					return {
						text: 'Enviar Boleta Electrónica', 
						function: () => {
							this.transaction = transaction;
							this.OpenModalSendBoleta();
						},
						icon: 'invoice-send'
					};
				}
				else
				{
					return {
						text: 'Emitir Boleta Electrónica', 
						function: () => {
							this.transaction = transaction;
							this.SendBoleta();
						},
						icon: 'invoice'
					};
				}
			}
			return null;
		},
		FacturaOption(transaction){
			if(this.Local.modules.module_sii_factura){
				if(transaction.custom_data.factura){
					return {
						text: 'Enviar Factura Electrónica', 
						function: () => {
							this.transaction = transaction;
							this.OpenmodalSendDte();
						},
						icon: 'factura-send'
					};
				}else{
					return {
						text: 'Emitir Factura Electrónica', 
						function: () => {
							this.transaction = transaction;
							this.SendFactura();
						},
						icon: 'factura'
					};
				}
			}
			return null;

		},

		OpenTicket(transaction)
		{
			this.transaction = transaction;
			this.modalTicket = true;

			//auto imprimir boleta generada en el servidor
			if(transaction.custom_data.boleta_auto_print)
			{
				this.Util.NotifyService('reprint', {
					data: transaction,
					id: transaction.custom_data.boleta_auto_print,
					types: 'BOLETA',
					event: 'CREATED',
				});
			}

		},

		PaymentOptions(transaction)
		{
			if(transaction) this.transaction = transaction;
			var ret = [];
			if(this.canSendDepositData)
			{
				ret.push({text: 'Enviar Datos Bancarios', function: () => {this.SendDepositData(this.transaction.customer && this.transaction.customer.phone ? this.transaction.customer.phone : '+569')}, icon: 'bank'});
			}
			if(this.transaction && this.transaction.payment.length == 1 && (this.transaction.payment[0].method == 'ONLINE' || this.transaction.payment[0].method == 'ONLINE_GETNET' || this.transaction.payment[0].method == 'ONLINE_MERCADO_PAGO') && !this.transaction.paid_at)
			{
				ret.push({text: 'Enviar Link de Pago', function: () => {this.OpenModalSendOnlinePaymentLink();}, icon: 'mobile-payment'});
			}
			/*
			if(this.transaction && this.transaction.payment.length == 1 && this.transaction.payment[0].method == 'ONLINE' && this.transaction.paid_at && this.transaction.custom_data.transbank)
			{
				ret.push({text: 'Reembolsar Pago Online', function: () => {this.RefundTransbankPayment()}})
			}
			*/

			return ret;
		},
		OpenModalSendOnlinePaymentLink()
		{

			let method = this.transaction.payment[0].method;
			if (method === 'ONLINE_GETNET' || method === 'ONLINE_MERCADO_PAGO') {

				this.Loading();

				let endpoint = method === 'ONLINE_GETNET' ? 'getnet' : 'mercadopago';

				axios.post(`/transaction/online/${endpoint}`, this.transaction)
					.then(({ data }) => {
						this.modalSendOnlinePaymentLink = {
							phone: this.transaction.customer && this.transaction.customer.phone ? this.transaction.customer.phone : '+569',
							paymentUrl: data.processUrl,
						};

						let ret = JSON.parse(localStorage.customerscreen || "{}");
						if(ret) ret.urlProcess = data.processUrl;
						localStorage.customerscreen = JSON.stringify(ret);

						this.Response(data);
					})
					.catch(err => {
						this.Response(err);
					});

				return;
			}

			this.modalSendOnlinePaymentLink = {
				phone: this.transaction.customer && this.transaction.customer.phone ? this.transaction.customer.phone : '+569',
				paymentUrl: process.env.NODE_ENV === 'production' ? `https://payment.influye.app/local/${this.transaction.code}` : `${this.Util.backend}webpay/pos/${this.transaction.code}`,
			}
		},

		RefundTransbankPayment(transaction)
		{
			if(transaction) this.transaction = transaction;
			this.Loading();
			axios.post(`/transaction/${this.transaction.id}/transbank/refund`).then(res => {
				console.log(res.data);
				this.Response(res);
			}).catch(err => {
				this.Response(err);
			});
		},
		BlockCustomer(ticket)
        {
            var data = {
                name: ticket.customer.name,
                phone: ticket.customer.phone, 
                email: ticket.customer.email,
                ip: null
            };
            this.Loading();
            axios.post(`/customers/${this.Local.id}/iap/block`, data).then(res => {
                this.Info('Cliente bloqueado exitosamente');
            }).catch(err => {
                this.Response(err);
            });
        },
		openModalPya(){
			this.$refs.estimatePya.Open(this.transaction);
			this.modalDelivery = null;
		},
		getRevisionOrder(transaction){
			this.Loading();
			axios.get(`/transaction/${transaction.id}/detail/revision`).then( ({data}) => {
				this.Response(data);
				if(!data.status) return this.Info(data.msg);
				this.modalRevisionTransaction = data.revisions;
			}).catch(err => {
				this.Response(err);
			});
		},
		DictTagDinerName(value){
            if((!this.transaction && !this.transaction.custom_data['diners_names']) || !value) return
            let diner = this.transaction.custom_data['diners_names'][value]
            return diner
        },
        async EditCompletedTransaction(value){
            this.Loading();
			await axios.get(`/sale/${this.Local.id}`).then( ({data}) => {
				this.Response(data);
				this.saleData = data;
				this.modalEdit = this.transaction;
			}).catch(err => {
				this.Response(err);
			});

        },
		ShowPyaCourierLog(transaction) 
		{
			if(!transaction) transaction = this.transaction;
			this.Loading();
			axios.get(`/transaction/${transaction.id}/pya/courier/log`).then(res => {
				this.Info(res.data.log ? res.data.log : 'No hay datos');
			}).catch(err => {
				this.Response(err);
			});
		},
		ShowPyaCourierPIN(transaction) 
		{
			if(!transaction) transaction = this.transaction;
			this.Loading();
			axios.get(`/transaction/${transaction.id}/pya/courier/pin`).then(res => {
				this.Info(res.data.pin ? `PIN: ${res.data.pin}` : 'No hay PIN');
			}).catch(err => {
				this.Response(err);
			});
		},
		DiffHtml(html1, html2)
		{
			let tokens1 = {};
			let tokens2 = {};
			
			html1.querySelectorAll(`.revision-info`).forEach(child => {
				tokens1[child.innerHTML ] = true;
			});

			html2.querySelectorAll(`.revision-info`).forEach(child => {
				tokens2[child.innerHTML ] = true;
			});
			html1.querySelectorAll(`.revision-info`).forEach(child => {
				let childHtml = child.innerHTML ;
				if(!tokens2[childHtml]) child.classList.add('revision-deleted');
			});

			html2.querySelectorAll(`.revision-info`).forEach(child => {
				let childHtml = child.innerHTML ;
				if(!tokens1[childHtml]) child.classList.add('revision-added');
			});

		},
		TransactionStatus(transaction)
		{
			if(transaction.status.indexOf('DELETED-') > -1) return {text: 'Eliminada', class: 'cred'};
			if(transaction.status == 'DELIVERY' && transaction.custom_data.delivered_at) return {text: 'En tránsito (Marcada como entregada)', class: 'cyellow'};
			var status = {
				PENDING: {text: 'Pendiente', class: 'cyellow'},
				DELIVERY: {text: 'En tránsito', class: 'cblue'},
				CANCELLED: {text: 'Cancelada', class: 'cred'},
				COMPLETED: {text: 'Completada', class: 'cgreen'},
				COMPLETED: {text: 'Completada', class: 'cgreen'},
				SCHEDULED: {text: 'Pedido Agendado', class: 'cyellow'},
			}
			return status[transaction.status];
		},
		getTotalWithTips(transaction){
			let total = transaction.total_money || 0;

			if (
			transaction.custom_data &&
			transaction.custom_data.tips &&
			transaction.custom_data.tips.length
			) {
			const tipsTotal = transaction.custom_data.tips.reduce(
				(sum, tip) => sum + (Number(tip.total) || 0),
				0
			);
			total += tipsTotal;
			}

			return total;
		},
		async SendWspMessageOrderOnline()
		{
			const customer = this.transaction.customer
			if(!customer || !customer.phone) return
			
			try{
				
				if(!this.defaultMessages){
					this.Loading();
					const res = await axios.get(`/local/${this.Local.id}/messages`);
					this.defaultMessages = res.data;
					this.Response(res);
				} 

				this.Util.OpenWhatsapp(customer.phone, this.defaultMessages.default_order_online_message, {'{name}': customer.name});
			}
			catch(err){
				this.Response(err);
			}

		},
		getPlatformItems() {
			return [
			{ text: 'Ninguno', value: 'SCHEDULE' },
			...this.filteredOverwrite
				.map(i => ({
					text: Util.Platforms[i.type] || i.type,
					value: i.type
				}))
				.filter(i => i.text !== 'SCHEDULE')
			]
		},
		Reprint(transaction, type, event) {
			this.Util.PrintTransaction(transaction, type, event);
			if(this.modal) this.GetRevisionsNumber(transaction);
		},
		ApplyReprintFilter(transaction) {
			if (transaction && transaction.custom_data && transaction.custom_data.reprint_historial && transaction.custom_data.reprint_historial.length) {
				let reprint = Util.Copy(transaction.custom_data.reprint_historial);
				if (transaction.edit_at) reprint = reprint.filter(re => re.timestamp > transaction.edit_at)
				transaction.custom_data.reprint_historial = reprint;
			}
			return transaction;
		},
		GetRevisionsNumber(transaction) {
			if(!this.transaction || this.Auth.role.indexOf('admin') == -1) return;
			axios.get(`/transaction/${typeof transaction == 'number' ? transaction : transaction.id}/revisions/number`).then(res => {
				this.hasRevisions = res.data.count;
				this.transaction.custom_data = res.data.custom_data;
			});
		},
		shouldShowChange(transaction) {
			if (!transaction || !transaction.payment) return false;

			const hasCash = transaction.payment.some(p => p.method === 'CASH');
			if (!hasCash) return false;

			return this.totalChange(transaction) > 0;
		},
		totalChange(transaction) {
			if (!transaction || !transaction.payment) return 0;

			return transaction.payment.reduce((acc, method, index) => {
				if (method.method !== 'CASH') return acc;

				let total = parseInt(method.subtotal) || 0;
				let cash = parseInt(method.cash) || 0;

				if (transaction.payment.length === 1) {
				total += this.Util.Sum(transaction.custom_data.tips, 'total');
				} else {
				total += this.Util.MethodTip(transaction, index);
				}

				let change = cash - total;

				if (change <= 0) return acc;

				change = Math.floor(change / 10) * 10;

				return acc + change;

			}, 0);
		},
		DinersNames(diners) {
			if (!diners) return '';

			return Object.values(diners)
				.map(diner => Util.CustomerHasPhone(diner, ' ★'))
				.filter(name => !/^C\d+$/.test(name))
				.join(', ');
		}
	},
	computed: {
		deliveryModalTitle() {
			if (!this.modalDelivery) return '';
			const n = this.modalDelivery.bulkTickets && this.modalDelivery.bulkTickets.length;
			if (n) return `Seleccionar Repartidor (${n} pedidos)`;
			if (this.modalDelivery.mode === 'assign') return 'Asignar Repartidor';
			return this.modalDelivery.edit ? 'Cambiar Repartidor' : 'Seleccionar Repartidor';
		},
		canOptions() {
			if(this.transaction && this.transaction.status && this.transaction.status.indexOf('DELETED-') > -1) return false;
			return this.Auth.role != 'delivery';
		},
		canDelete() {
			if(!this.transaction) return false;
			if(this.Local.type !== 'LOCAL') return false;
			//if(this.transaction.iap) return false;
			if(this.Auth.role.indexOf('admin') == -1) return false;
			return true;
			//var moment = require('moment');
			//return this.transaction.created_at >= moment().unix() - (60*60*24*2);
		},
		canCancel() {
			if(!this.transaction) return false;
			if(this.Local.type !== 'LOCAL') return false;
			if(this.Auth.role.indexOf('admin') == -1) {
				if(this.Auth.restrictions && !this.Auth.restrictions.cancel_transactions) return false;
			}
			return true;
		},
		canEditPayment() 
		{
			return false;
			if(this.transaction.iap && this.transaction.payment[0].method == 'ONLINE') return false;
			if(this.Auth.role.indexOf('admin') == -1 && !this.Auth.restrictions.edit_transactions) return false;
			if(this.transaction === null) return false;
			if(this.transaction.status !== 'PENDING' && this.transaction.status !== 'DELIVERY') return false;
			return true;
		},
		//@computed <Bool> determina si la transacción se puede reembolsar
		canRefund()
		{
			if(this.Local.type !== 'LOCAL') return false;
			return this.transaction && this.transaction.status == 'COMPLETED' && this.Auth.role.indexOf('admin') > -1 && !this.transaction.custom_data.refund_at;
		},
		canSendDepositData()
		{
			if(!this.transaction) return false;
			for(var i = 0; i < this.transaction.payment.length; i++)
				if(this.transaction.payment[i].method.toUpperCase().indexOf('TRANSFERENCIA') > -1 || this.transaction.payment[i].method == 'BANK_DEPOSIT') return true;
			return false;
		},
		previews() {
			if(!this.transaction) return [];
			if(this.revision !== null)
			{
				let index = this.revisions.length - this.revision - 1;
				let current = this.ApplyReprintFilter(this.revisions[index].data.data);
				let previous = index - 1 < 0 ? this.ApplyReprintFilter(this.transaction) : this.ApplyReprintFilter(this.revisions[index - 1].data.data);
				return [current, previous];
			}
			this.ApplyReprintFilter(this.transaction);
			return [this.transaction];
		},
		canBlockCustomers() {
			if(!this.transaction) return false;
            return (this.Auth.role.indexOf('admin') > -1 || this.Auth.restrictions.block_customers) && this.transaction.source == 'INFLUYE_WEB';
        },
		filteredOverwrite(){
            if(!this.saleData || !this.saleData.overwrites) return;
            if(!this.typeMenu) return this.saleData.overwrites;
            let overwrites = Util.Copy(this.saleData.overwrites);
            const filtered = overwrites.filter(overwrite => overwrite.type  == this.typeMenu);
            return filtered;
        },
	},
	watch: {
		previews(n, o) {
			if(n.length > 0 && this.$refs.revisions && this.$refs.revisions.length > 0)
			{
				setTimeout(() => {
					this.$refs.revisions[0].querySelectorAll('.revision-info').forEach(child => {
						child.classList.remove('revision-deleted');
						child.classList.remove('revision-added');
					});
					if(n.length > 1)
					{
						this.$refs.revisions[1].querySelectorAll('.revision-info').forEach(child => {
							child.classList.remove('revision-deleted');
							child.classList.remove('revision-added');
						});
					}
				}, 10);
			}
			if(n.length > 1)
			{
				setTimeout(() => {this.DiffHtml(this.$refs.revisions[0], this.$refs.revisions[1])}, 11);		
			}
		}
	}
}
</script>
<style lang="scss">
.method {
	border-bottom: 1px solid whitesmoke;
	margin-bottom: 10px;
	padding-bottom: 10px;
}
.method:last-child {
	margin-bottom: 0px;
	padding-bottom: 0px;
	border-bottom: none;
}
.customer-divide {
	margin-left: 5px;
	border-radius: 50px;
	width: 30px;
	height: 30px;
	display: flex;
	justify-content: center;
	align-items: center;
	color: var(--white);
	background-color: var(--gray-2);
	font-weight: bold;
	cursor: pointer;
}
.customer-divide.selected {
	background-color: var(--blue-2) !important;
}

.tag-total-modifiers {
	font-size: 12px;
    font-weight: normal;
    background-color: var(--gray-2-5);
    color: var(--color-preparation-pending);
    padding: 1px 5px;
    border-radius: 5px;
	margin-left: 3px;
}

.dark {
	.customer-divide {
		background-color: var(--dark-bg-0);
	}
	.tag-total-modifiers {
		background-color: var(--dark-bg-3);
		color: var(--color-preparation-pending);
	}
}
.revision-deleted {
	position: relative;
	&::before {
		content: '';
		position: absolute;
		left: -5px;
		right: -5px;
		top: -5px;
		bottom: -5px;
		border: 1px solid var(--red);
		border-radius: 5px;
		box-shadow: 0px 0px 5px var(--red);
		pointer-events: none;
	}
	&.small {
		&::before {
			content: '';
			left: -5px;
			right: -5px;
			top: -1px;
			bottom: -1px;
		}	
	}
}
.revision-added {
	position: relative;
	&::before {
		content: '';
		position: absolute;
		left: -5px;
		right: -5px;
		top: -5px;
		bottom: -5px;
		border: 1px solid var(--green);
		border-radius: 5px;
		box-shadow: 0px 0px 5px var(--green);
		pointer-events: none;
	}
	&.small {
		&::before {
			content: '';
			left: -5px;
			right: -5px;
			top: -1px;
			bottom: -1px;
		}	
	}
}
</style>